/* tslint:disable */
/* eslint-disable */
/**
 * crowdtech
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import type { Configuration } from './configuration';
import type { AxiosPromise, AxiosInstance, RawAxiosRequestConfig } from 'axios';
import globalAxios from 'axios';
// Some imports not used depending on template conditions
// @ts-ignore
import { DUMMY_BASE_URL, assertParamExists, setApiKeyToObject, setBasicAuthToObject, setBearerAuthToObject, setOAuthToObject, setSearchParams, serializeDataIfNeeded, toPathString, createRequestFunction } from './common';
import type { RequestArgs } from './base';
// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS, BaseAPI, RequiredError, operationServerMap } from './base';

/**
 * 
 * @export
 * @interface AboutInformation
 */
export interface AboutInformation {
    /**
     * 
     * @type {string}
     * @memberof AboutInformation
     */
    'title': string;
    /**
     * 
     * @type {string}
     * @memberof AboutInformation
     */
    'description': string;
}
/**
 * 
 * @export
 * @interface AdminJobOffer
 */
export interface AdminJobOffer {
    /**
     * 
     * @type {number}
     * @memberof AdminJobOffer
     */
    'id': number;
    /**
     * 
     * @type {string}
     * @memberof AdminJobOffer
     */
    'salesforceJobId': string;
    /**
     * 
     * @type {string}
     * @memberof AdminJobOffer
     */
    'status': AdminJobOfferStatusEnum;
    /**
     * 
     * @type {string}
     * @memberof AdminJobOffer
     */
    'title': string;
}

export const AdminJobOfferStatusEnum = {
    Open: 'open',
    Close: 'close'
} as const;

export type AdminJobOfferStatusEnum = typeof AdminJobOfferStatusEnum[keyof typeof AdminJobOfferStatusEnum];

/**
 * 
 * @export
 * @interface ApiV1UsersTopInformationGet200ResponseInner
 */
export interface ApiV1UsersTopInformationGet200ResponseInner {
    /**
     * 
     * @type {number}
     * @memberof ApiV1UsersTopInformationGet200ResponseInner
     */
    'id'?: number;
    /**
     * 
     * @type {string}
     * @memberof ApiV1UsersTopInformationGet200ResponseInner
     */
    'title'?: string;
    /**
     * 
     * @type {string}
     * @memberof ApiV1UsersTopInformationGet200ResponseInner
     */
    'category'?: string;
    /**
     * 
     * @type {string}
     * @memberof ApiV1UsersTopInformationGet200ResponseInner
     */
    'informedOn'?: string;
}
/**
 * 
 * @export
 * @interface ApiV1UsersTopJobOfferSearchMasterSkillsGet200ResponseInner
 */
export interface ApiV1UsersTopJobOfferSearchMasterSkillsGet200ResponseInner {
    /**
     * 
     * @type {number}
     * @memberof ApiV1UsersTopJobOfferSearchMasterSkillsGet200ResponseInner
     */
    'id'?: number;
    /**
     * 
     * @type {string}
     * @memberof ApiV1UsersTopJobOfferSearchMasterSkillsGet200ResponseInner
     */
    'name'?: string;
}
/**
 * 
 * @export
 * @interface ArticlesInformation
 */
export interface ArticlesInformation {
    /**
     * 
     * @type {string}
     * @memberof ArticlesInformation
     */
    'title': string;
    /**
     * 
     * @type {string}
     * @memberof ArticlesInformation
     */
    'url': string;
}
/**
 * @type BadRequestError
 * @export
 */
export type BadRequestError = ContractExtensionRequestBadRequest | DuplicateSkillError | UpdateClientStaffPasswordBadRequest | VerifyClientStaffEmailBadRequest;

/**
 * 
 * @export
 * @interface Bill
 */
export interface Bill {
    /**
     * 
     * @type {number}
     * @memberof Bill
     */
    'id': number;
    /**
     * 
     * @type {string}
     * @memberof Bill
     */
    'status': BillStatusEnum;
    /**
     * 
     * @type {string}
     * @memberof Bill
     */
    'targetMonth': string;
    /**
     * 
     * @type {BillProject}
     * @memberof Bill
     */
    'project': BillProject;
    /**
     * 
     * @type {BillInvoice}
     * @memberof Bill
     */
    'invoice': BillInvoice;
    /**
     * 
     * @type {BillUser}
     * @memberof Bill
     */
    'user': BillUser;
}

export const BillStatusEnum = {
    ConfirmRequested: 'confirmRequested',
    Confirmed: 'confirmed',
    Paid: 'paid'
} as const;

export type BillStatusEnum = typeof BillStatusEnum[keyof typeof BillStatusEnum];

/**
 * 
 * @export
 * @interface BillCount
 */
export interface BillCount {
    /**
     * 
     * @type {number}
     * @memberof BillCount
     */
    'confirmRequested'?: number;
    /**
     * 
     * @type {number}
     * @memberof BillCount
     */
    'confirmed'?: number;
    /**
     * 
     * @type {number}
     * @memberof BillCount
     */
    'paid'?: number;
}
/**
 * 
 * @export
 * @interface BillDetail
 */
export interface BillDetail {
    /**
     * 
     * @type {string}
     * @memberof BillDetail
     */
    'targetMonth': string;
    /**
     * 
     * @type {number}
     * @memberof BillDetail
     */
    'subtotalAmount': number;
    /**
     * 
     * @type {string}
     * @memberof BillDetail
     */
    'consumptionTaxRate': string;
    /**
     * 
     * @type {number}
     * @memberof BillDetail
     */
    'consumptionTaxAmount': number;
    /**
     * 
     * @type {number}
     * @memberof BillDetail
     */
    'expenseAmount': number;
    /**
     * 
     * @type {BillDetailInvoice}
     * @memberof BillDetail
     */
    'invoice': BillDetailInvoice;
}
/**
 * 
 * @export
 * @interface BillDetailInvoice
 */
export interface BillDetailInvoice {
    /**
     * 
     * @type {string}
     * @memberof BillDetailInvoice
     */
    'clientName': string;
    /**
     * 
     * @type {string}
     * @memberof BillDetailInvoice
     */
    'billedOn': string;
    /**
     * 
     * @type {string}
     * @memberof BillDetailInvoice
     */
    'billLimitedOn': string;
    /**
     * 
     * @type {number}
     * @memberof BillDetailInvoice
     */
    'amount': number;
    /**
     * 
     * @type {string}
     * @memberof BillDetailInvoice
     */
    'invoiceNumber': string;
    /**
     * 
     * @type {Array<BillDetailInvoiceBreakdownsInner>}
     * @memberof BillDetailInvoice
     */
    'breakdowns': Array<BillDetailInvoiceBreakdownsInner>;
}
/**
 * 
 * @export
 * @interface BillDetailInvoiceBreakdownsInner
 */
export interface BillDetailInvoiceBreakdownsInner {
    /**
     * 
     * @type {string}
     * @memberof BillDetailInvoiceBreakdownsInner
     */
    'itemName': string | null;
    /**
     * 
     * @type {string}
     * @memberof BillDetailInvoiceBreakdownsInner
     */
    'workerName': string | null;
    /**
     * 
     * @type {number}
     * @memberof BillDetailInvoiceBreakdownsInner
     */
    'unitPrice': number | null;
    /**
     * 
     * @type {string}
     * @memberof BillDetailInvoiceBreakdownsInner
     */
    'quantity': string | null;
    /**
     * 
     * @type {number}
     * @memberof BillDetailInvoiceBreakdownsInner
     */
    'amount': number | null;
}
/**
 * 
 * @export
 * @interface BillInvoice
 */
export interface BillInvoice {
    /**
     * 
     * @type {string}
     * @memberof BillInvoice
     */
    'clientName': string;
    /**
     * 
     * @type {string}
     * @memberof BillInvoice
     */
    'billedOn': string;
    /**
     * 
     * @type {string}
     * @memberof BillInvoice
     */
    'billLimitedOn': string;
    /**
     * 
     * @type {number}
     * @memberof BillInvoice
     */
    'amount': number;
    /**
     * 
     * @type {string}
     * @memberof BillInvoice
     */
    'invoiceNumber': string;
}
/**
 * 
 * @export
 * @interface BillProject
 */
export interface BillProject {
    /**
     * 
     * @type {string}
     * @memberof BillProject
     */
    'title': string;
}
/**
 * 
 * @export
 * @interface BillUser
 */
export interface BillUser {
    /**
     * 
     * @type {string}
     * @memberof BillUser
     */
    'fullName': string;
}
/**
 * 
 * @export
 * @interface BillYear
 */
export interface BillYear {
    /**
     * 
     * @type {number}
     * @memberof BillYear
     */
    'year': number;
    /**
     * 
     * @type {number}
     * @memberof BillYear
     */
    'count': number;
}
/**
 * 
 * @export
 * @interface ClientContract
 */
export interface ClientContract {
    /**
     * 
     * @type {string}
     * @memberof ClientContract
     */
    'description'?: string;
    /**
     * 
     * @type {string}
     * @memberof ClientContract
     */
    'userFullName'?: string;
}
/**
 * 
 * @export
 * @interface ClientContractExtensionRequest
 */
export interface ClientContractExtensionRequest {
    /**
     * 
     * @type {ContractExtensionRequest1}
     * @memberof ClientContractExtensionRequest
     */
    'contractExtensionRequest'?: ContractExtensionRequest1;
}
/**
 * 
 * @export
 * @interface ClientLogin200Response
 */
export interface ClientLogin200Response {
    /**
     * 
     * @type {number}
     * @memberof ClientLogin200Response
     */
    'id': number;
    /**
     * 
     * @type {string}
     * @memberof ClientLogin200Response
     */
    'message': string;
}
/**
 * 
 * @export
 * @interface ClientLoginRequest
 */
export interface ClientLoginRequest {
    /**
     * 
     * @type {string}
     * @memberof ClientLoginRequest
     */
    'email': string;
    /**
     * 
     * @type {string}
     * @memberof ClientLoginRequest
     */
    'password': string;
}
/**
 * @type ConflictError
 * @export
 */
export type ConflictError = JobOfferApplicationError;

/**
 * 
 * @export
 * @interface ContractExtensionContractRequest
 */
export interface ContractExtensionContractRequest {
    /**
     * 契約延長の期限日
     * @type {string}
     * @memberof ContractExtensionContractRequest
     */
    'deadline': string;
}
/**
 * 
 * @export
 * @interface ContractExtensionRequest
 */
export interface ContractExtensionRequest {
    /**
     * 
     * @type {number}
     * @memberof ContractExtensionRequest
     */
    'id': number;
    /**
     * 
     * @type {QuestionnaireStatus}
     * @memberof ContractExtensionRequest
     */
    'status': QuestionnaireStatus;
    /**
     * 
     * @type {string}
     * @memberof ContractExtensionRequest
     */
    'createdAt': string;
    /**
     * 
     * @type {string}
     * @memberof ContractExtensionRequest
     */
    'expiresAt': string;
    /**
     * 
     * @type {string}
     * @memberof ContractExtensionRequest
     */
    'category': ContractExtensionRequestCategoryEnum;
    /**
     * 
     * @type {string}
     * @memberof ContractExtensionRequest
     */
    'url': string;
    /**
     * 
     * @type {ContractExtensionRequestProject}
     * @memberof ContractExtensionRequest
     */
    'project': ContractExtensionRequestProject;
    /**
     * 
     * @type {BillUser}
     * @memberof ContractExtensionRequest
     */
    'user': BillUser;
    /**
     * 
     * @type {Array<ExtensionSurveyAnswer>}
     * @memberof ContractExtensionRequest
     */
    'answers'?: Array<ExtensionSurveyAnswer>;
    /**
     * 
     * @type {ContractExtensionContractRequest}
     * @memberof ContractExtensionRequest
     */
    'clientContractExtensionContractRequest': ContractExtensionContractRequest;
}

export const ContractExtensionRequestCategoryEnum = {
    ContractExtensionRequest: 'contractExtensionRequest'
} as const;

export type ContractExtensionRequestCategoryEnum = typeof ContractExtensionRequestCategoryEnum[keyof typeof ContractExtensionRequestCategoryEnum];

/**
 * 
 * @export
 * @interface ContractExtensionRequest1
 */
export interface ContractExtensionRequest1 {
    /**
     * 
     * @type {ClientContract}
     * @memberof ContractExtensionRequest1
     */
    'contract'?: ClientContract;
    /**
     * 
     * @type {Array<ExtensionSurveyAnswerItem>}
     * @memberof ContractExtensionRequest1
     */
    'extensionSurveyAnswer'?: Array<ExtensionSurveyAnswerItem>;
}
/**
 * 延長アンケート更新エラー
 * @export
 * @interface ContractExtensionRequestBadRequest
 */
export interface ContractExtensionRequestBadRequest {
    /**
     * 
     * @type {string}
     * @memberof ContractExtensionRequestBadRequest
     */
    'operationId': ContractExtensionRequestBadRequestOperationIdEnum;
    /**
     * 
     * @type {{ [key: string]: any; }}
     * @memberof ContractExtensionRequestBadRequest
     */
    'errors': { [key: string]: any; };
}

export const ContractExtensionRequestBadRequestOperationIdEnum = {
    UpdateClientContractExtensionRequest: 'updateClientContractExtensionRequest'
} as const;

export type ContractExtensionRequestBadRequestOperationIdEnum = typeof ContractExtensionRequestBadRequestOperationIdEnum[keyof typeof ContractExtensionRequestBadRequestOperationIdEnum];

/**
 * 
 * @export
 * @interface ContractExtensionRequestProject
 */
export interface ContractExtensionRequestProject {
    /**
     * 
     * @type {string}
     * @memberof ContractExtensionRequestProject
     */
    'title': string;
    /**
     * 
     * @type {string}
     * @memberof ContractExtensionRequestProject
     */
    'startOn': string;
    /**
     * 
     * @type {string}
     * @memberof ContractExtensionRequestProject
     */
    'endOn': string;
}
/**
 * 
 * @export
 * @interface CreateInvoiceNumber200Response
 */
export interface CreateInvoiceNumber200Response {
    /**
     * 
     * @type {string}
     * @memberof CreateInvoiceNumber200Response
     */
    'status': string;
}
/**
 * 
 * @export
 * @interface CreateInvoiceNumberRequest
 */
export interface CreateInvoiceNumberRequest {
    /**
     * 
     * @type {string}
     * @memberof CreateInvoiceNumberRequest
     */
    'registrated_number': string;
}
/**
 * 
 * @export
 * @interface CreateJobOfferApplication200Response
 */
export interface CreateJobOfferApplication200Response {
    /**
     * 
     * @type {string}
     * @memberof CreateJobOfferApplication200Response
     */
    'status'?: string;
}
/**
 * 
 * @export
 * @interface CreateJobOfferApplicationRequest
 */
export interface CreateJobOfferApplicationRequest {
    /**
     * 
     * @type {CreateJobOfferApplicationRequestJobOfferApplication}
     * @memberof CreateJobOfferApplicationRequest
     */
    'job_offer_application'?: CreateJobOfferApplicationRequestJobOfferApplication;
}
/**
 * 
 * @export
 * @interface CreateJobOfferApplicationRequestJobOfferApplication
 */
export interface CreateJobOfferApplicationRequestJobOfferApplication {
    /**
     * 
     * @type {CreateJobOfferApplicationRequestJobOfferApplicationJobOfferApplicationCommentAttributes}
     * @memberof CreateJobOfferApplicationRequestJobOfferApplication
     */
    'job_offer_application_comment_attributes'?: CreateJobOfferApplicationRequestJobOfferApplicationJobOfferApplicationCommentAttributes;
}
/**
 * 
 * @export
 * @interface CreateJobOfferApplicationRequestJobOfferApplicationJobOfferApplicationCommentAttributes
 */
export interface CreateJobOfferApplicationRequestJobOfferApplicationJobOfferApplicationCommentAttributes {
    /**
     * 
     * @type {string}
     * @memberof CreateJobOfferApplicationRequestJobOfferApplicationJobOfferApplicationCommentAttributes
     */
    'skills'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof CreateJobOfferApplicationRequestJobOfferApplicationJobOfferApplicationCommentAttributes
     */
    'questions'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof CreateJobOfferApplicationRequestJobOfferApplicationJobOfferApplicationCommentAttributes
     */
    'others'?: string | null;
}
/**
 * 
 * @export
 * @interface CreateUserReferralRequest
 */
export interface CreateUserReferralRequest {
    /**
     * 紹介用URLのトークン
     * @type {string}
     * @memberof CreateUserReferralRequest
     */
    'key'?: string;
    /**
     * 
     * @type {CreateUserReferralRequestUserRegistrationForm}
     * @memberof CreateUserReferralRequest
     */
    'userRegistrationForm'?: CreateUserReferralRequestUserRegistrationForm;
}
/**
 * 
 * @export
 * @interface CreateUserReferralRequestUserRegistrationForm
 */
export interface CreateUserReferralRequestUserRegistrationForm {
    /**
     * 
     * @type {string}
     * @memberof CreateUserReferralRequestUserRegistrationForm
     */
    'password': string;
    /**
     * 
     * @type {number}
     * @memberof CreateUserReferralRequestUserRegistrationForm
     */
    'occupationId': number;
    /**
     * 
     * @type {string}
     * @memberof CreateUserReferralRequestUserRegistrationForm
     */
    'email': string;
    /**
     * 
     * @type {string}
     * @memberof CreateUserReferralRequestUserRegistrationForm
     */
    'firstName': string;
    /**
     * 
     * @type {string}
     * @memberof CreateUserReferralRequestUserRegistrationForm
     */
    'lastName': string;
    /**
     * 
     * @type {string}
     * @memberof CreateUserReferralRequestUserRegistrationForm
     */
    'firstNameKana': string;
    /**
     * 
     * @type {string}
     * @memberof CreateUserReferralRequestUserRegistrationForm
     */
    'lastNameKana': string;
    /**
     * 
     * @type {string}
     * @memberof CreateUserReferralRequestUserRegistrationForm
     */
    'tel': string;
    /**
     * 
     * @type {number}
     * @memberof CreateUserReferralRequestUserRegistrationForm
     */
    'prefectureId': number;
    /**
     * 
     * @type {string}
     * @memberof CreateUserReferralRequestUserRegistrationForm
     */
    'birthday': string;
}
/**
 * 
 * @export
 * @interface CreateUserSearchingBookmark200Response
 */
export interface CreateUserSearchingBookmark200Response {
    /**
     * 
     * @type {number}
     * @memberof CreateUserSearchingBookmark200Response
     */
    'status'?: number;
    /**
     * 
     * @type {string}
     * @memberof CreateUserSearchingBookmark200Response
     */
    'message'?: string;
}
/**
 * 
 * @export
 * @interface CreateUserSearchingHistory200Response
 */
export interface CreateUserSearchingHistory200Response {
    /**
     * 
     * @type {number}
     * @memberof CreateUserSearchingHistory200Response
     */
    'id'?: number;
}
/**
 * 
 * @export
 * @interface CreateUserSearchingHistory400Response
 */
export interface CreateUserSearchingHistory400Response {
    /**
     * 
     * @type {string}
     * @memberof CreateUserSearchingHistory400Response
     */
    'operationId': string;
    /**
     * 
     * @type {CreateUserSearchingHistory400ResponseErrors}
     * @memberof CreateUserSearchingHistory400Response
     */
    'errors'?: CreateUserSearchingHistory400ResponseErrors;
}
/**
 * 
 * @export
 * @interface CreateUserSearchingHistory400ResponseErrors
 */
export interface CreateUserSearchingHistory400ResponseErrors {
    /**
     * 
     * @type {Array<string>}
     * @memberof CreateUserSearchingHistory400ResponseErrors
     */
    'query'?: Array<string>;
}
/**
 * 
 * @export
 * @interface CreateUserSearchingHistoryRequest
 */
export interface CreateUserSearchingHistoryRequest {
    /**
     * 
     * @type {string}
     * @memberof CreateUserSearchingHistoryRequest
     */
    'word'?: string;
    /**
     * 
     * @type {number}
     * @memberof CreateUserSearchingHistoryRequest
     */
    'minPrice'?: number;
    /**
     * 
     * @type {number}
     * @memberof CreateUserSearchingHistoryRequest
     */
    'maxPrice'?: number;
    /**
     * 
     * @type {Array<number>}
     * @memberof CreateUserSearchingHistoryRequest
     */
    'workingDays'?: Array<number>;
    /**
     * 
     * @type {Array<number>}
     * @memberof CreateUserSearchingHistoryRequest
     */
    'workStyles'?: Array<number>;
    /**
     * 
     * @type {Array<number>}
     * @memberof CreateUserSearchingHistoryRequest
     */
    'categoryIds'?: Array<number>;
    /**
     * 
     * @type {Array<number>}
     * @memberof CreateUserSearchingHistoryRequest
     */
    'prefectureIds'?: Array<number>;
    /**
     * 
     * @type {Array<number>}
     * @memberof CreateUserSearchingHistoryRequest
     */
    'skillIds'?: Array<number>;
    /**
     * 
     * @type {Array<number>}
     * @memberof CreateUserSearchingHistoryRequest
     */
    'appealIds'?: Array<number>;
}
/**
 * スキル重複エラー
 * @export
 * @interface DuplicateSkillError
 */
export interface DuplicateSkillError {
    /**
     * 
     * @type {string}
     * @memberof DuplicateSkillError
     */
    'operationId': DuplicateSkillErrorOperationIdEnum;
    /**
     * 
     * @type {string}
     * @memberof DuplicateSkillError
     */
    'error': string;
}

export const DuplicateSkillErrorOperationIdEnum = {
    UpdateUserSkillRelations: 'updateUserSkillRelations'
} as const;

export type DuplicateSkillErrorOperationIdEnum = typeof DuplicateSkillErrorOperationIdEnum[keyof typeof DuplicateSkillErrorOperationIdEnum];

/**
 * 
 * @export
 * @interface ErrorMessage
 */
export interface ErrorMessage {
    /**
     * 
     * @type {string}
     * @memberof ErrorMessage
     */
    'operationId': string;
    /**
     * 
     * @type {string}
     * @memberof ErrorMessage
     */
    'error': string;
}
/**
 * 
 * @export
 * @interface ExtensionSurveyAnswer
 */
export interface ExtensionSurveyAnswer {
    /**
     * 
     * @type {string}
     * @memberof ExtensionSurveyAnswer
     */
    'question': string;
    /**
     * 
     * @type {string}
     * @memberof ExtensionSurveyAnswer
     */
    'answer': string;
}
/**
 * 
 * @export
 * @interface ExtensionSurveyAnswerItem
 */
export interface ExtensionSurveyAnswerItem {
    /**
     * 
     * @type {any}
     * @memberof ExtensionSurveyAnswerItem
     */
    'id'?: any | null;
    /**
     * 
     * @type {any}
     * @memberof ExtensionSurveyAnswerItem
     */
    'answer'?: any | null;
    /**
     * 
     * @type {ExtensionSurveyQuestion}
     * @memberof ExtensionSurveyAnswerItem
     */
    'extensionSurveyQuestion'?: ExtensionSurveyQuestion;
}
/**
 * 
 * @export
 * @interface ExtensionSurveyQuestion
 */
export interface ExtensionSurveyQuestion {
    /**
     * 
     * @type {number}
     * @memberof ExtensionSurveyQuestion
     */
    'id'?: number;
    /**
     * 
     * @type {boolean}
     * @memberof ExtensionSurveyQuestion
     */
    'required'?: boolean;
    /**
     * 
     * @type {string}
     * @memberof ExtensionSurveyQuestion
     */
    'format'?: string;
    /**
     * 
     * @type {Array<string>}
     * @memberof ExtensionSurveyQuestion
     */
    'optionsForSelect'?: Array<string>;
    /**
     * 
     * @type {string}
     * @memberof ExtensionSurveyQuestion
     */
    'question'?: string;
    /**
     * 
     * @type {boolean}
     * @memberof ExtensionSurveyQuestion
     */
    'displayFlag'?: boolean;
}
/**
 * 
 * @export
 * @interface FeaturedJobOffer
 */
export interface FeaturedJobOffer {
    /**
     * 
     * @type {FeaturedJobOfferJobOffer}
     * @memberof FeaturedJobOffer
     */
    'jobOffer'?: FeaturedJobOfferJobOffer;
    /**
     * 
     * @type {string}
     * @memberof FeaturedJobOffer
     */
    'skillName'?: string;
}
/**
 * 
 * @export
 * @interface FeaturedJobOfferJobOffer
 */
export interface FeaturedJobOfferJobOffer {
    /**
     * 
     * @type {number}
     * @memberof FeaturedJobOfferJobOffer
     */
    'id'?: number;
    /**
     * 
     * @type {string}
     * @memberof FeaturedJobOfferJobOffer
     */
    'title'?: string;
    /**
     * 
     * @type {number}
     * @memberof FeaturedJobOfferJobOffer
     */
    'maxUnitPrice'?: number;
}
/**
 * 
 * @export
 * @interface GetAppeals200ResponseInner
 */
export interface GetAppeals200ResponseInner {
    /**
     * 
     * @type {number}
     * @memberof GetAppeals200ResponseInner
     */
    'id': number;
    /**
     * 
     * @type {string}
     * @memberof GetAppeals200ResponseInner
     */
    'description': string;
}
/**
 * 
 * @export
 * @interface GetJobOffersCategories200ResponseInner
 */
export interface GetJobOffersCategories200ResponseInner {
    /**
     * 
     * @type {number}
     * @memberof GetJobOffersCategories200ResponseInner
     */
    'id': number;
    /**
     * 
     * @type {string}
     * @memberof GetJobOffersCategories200ResponseInner
     */
    'name': string;
    /**
     * 
     * @type {Array<JobOfferCategory>}
     * @memberof GetJobOffersCategories200ResponseInner
     */
    'categories': Array<JobOfferCategory>;
}
/**
 * 
 * @export
 * @interface GetUserJobOffersCount200Response
 */
export interface GetUserJobOffersCount200Response {
    /**
     * 
     * @type {number}
     * @memberof GetUserJobOffersCount200Response
     */
    'count'?: number;
}
/**
 * 
 * @export
 * @interface GetUserProfile401Response
 */
export interface GetUserProfile401Response {
    /**
     * 
     * @type {string}
     * @memberof GetUserProfile401Response
     */
    'error'?: string;
}
/**
 * 
 * @export
 * @interface GetUserRecommendedJobOffers200ResponseInner
 */
export interface GetUserRecommendedJobOffers200ResponseInner {
    /**
     * 
     * @type {number}
     * @memberof GetUserRecommendedJobOffers200ResponseInner
     */
    'id': number;
    /**
     * 案件が募集中かどうか
     * @type {boolean}
     * @memberof GetUserRecommendedJobOffers200ResponseInner
     */
    'open': boolean;
    /**
     * 新着案件フラグ
     * @type {boolean}
     * @memberof GetUserRecommendedJobOffers200ResponseInner
     */
    'new': boolean;
    /**
     * 案件名
     * @type {string}
     * @memberof GetUserRecommendedJobOffers200ResponseInner
     */
    'title': string;
    /**
     * 最高月額単価
     * @type {number}
     * @memberof GetUserRecommendedJobOffers200ResponseInner
     */
    'maxUnitPrice': number | null;
    /**
     * 業務内容
     * @type {string}
     * @memberof GetUserRecommendedJobOffers200ResponseInner
     */
    'description': string;
    /**
     * オフィス所在地
     * @type {string}
     * @memberof GetUserRecommendedJobOffers200ResponseInner
     */
    'officeLocation'?: string;
    /**
     * 最低稼働日数
     * @type {number}
     * @memberof GetUserRecommendedJobOffers200ResponseInner
     */
    'requiredWorkingDays'?: number;
    /**
     * 
     * @type {UserJobOfferOccupation}
     * @memberof GetUserRecommendedJobOffers200ResponseInner
     */
    'occupation': UserJobOfferOccupation;
    /**
     * テック掲載スキル（1〜3）のリスト
     * @type {Array<JobOfferSkill>}
     * @memberof GetUserRecommendedJobOffers200ResponseInner
     */
    'skills'?: Array<JobOfferSkill>;
    /**
     * こだわりのリスト
     * @type {Array<UserJobOfferAppealsInner>}
     * @memberof GetUserRecommendedJobOffers200ResponseInner
     */
    'appeals'?: Array<UserJobOfferAppealsInner>;
    /**
     * マッチ度(%)。70%未満の場合は null
     * @type {number}
     * @memberof GetUserRecommendedJobOffers200ResponseInner
     */
    'matchRate'?: number | null;
}
/**
 * @type GetWorkPreference200Response
 * @export
 */
export type GetWorkPreference200Response = WorkPreference;

/**
 * 
 * @export
 * @interface IdentifyVerificationAddress
 */
export interface IdentifyVerificationAddress {
    /**
     * 
     * @type {number}
     * @memberof IdentifyVerificationAddress
     */
    'userId'?: number | null;
    /**
     * 
     * @type {string}
     * @memberof IdentifyVerificationAddress
     */
    'zip'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof IdentifyVerificationAddress
     */
    'prefecture'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof IdentifyVerificationAddress
     */
    'addressLine1'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof IdentifyVerificationAddress
     */
    'addressLine2'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof IdentifyVerificationAddress
     */
    'companyName'?: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof IdentifyVerificationAddress
     */
    'overseas'?: boolean | null;
    /**
     * 
     * @type {string}
     * @memberof IdentifyVerificationAddress
     */
    'countryName'?: string | null;
}
/**
 * 
 * @export
 * @interface JobOffer
 */
export interface JobOffer {
    /**
     * 
     * @type {number}
     * @memberof JobOffer
     */
    'id': number;
    /**
     * 
     * @type {string}
     * @memberof JobOffer
     */
    'title': string;
    /**
     * 
     * @type {number}
     * @memberof JobOffer
     */
    'maxUnitPrice': number;
    /**
     * 
     * @type {string}
     * @memberof JobOffer
     */
    'officeLocationPrefecture'?: string;
    /**
     * 
     * @type {string}
     * @memberof JobOffer
     */
    'officeLocation': string;
    /**
     * 
     * @type {string}
     * @memberof JobOffer
     */
    'requiredWorkingDays'?: string;
    /**
     * 
     * @type {string}
     * @memberof JobOffer
     */
    'description'?: string;
    /**
     * 
     * @type {string}
     * @memberof JobOffer
     */
    'productDescription'?: string;
    /**
     * 
     * @type {string}
     * @memberof JobOffer
     */
    'requirement'?: string;
    /**
     * 
     * @type {Array<JobOfferMasterSkillsInner>}
     * @memberof JobOffer
     */
    'masterSkills': Array<JobOfferMasterSkillsInner>;
    /**
     * 
     * @type {JobOfferMasterSkillsInner}
     * @memberof JobOffer
     */
    'occupation': JobOfferMasterSkillsInner;
}
/**
 * 
 * @export
 * @interface JobOfferApplicationError
 */
export interface JobOfferApplicationError {
    /**
     * 
     * @type {string}
     * @memberof JobOfferApplicationError
     */
    'operationId': JobOfferApplicationErrorOperationIdEnum;
    /**
     * 
     * @type {Array<string>}
     * @memberof JobOfferApplicationError
     */
    'error': Array<string>;
}

export const JobOfferApplicationErrorOperationIdEnum = {
    CreateJobOfferApplication: 'createJobOfferApplication'
} as const;

export type JobOfferApplicationErrorOperationIdEnum = typeof JobOfferApplicationErrorOperationIdEnum[keyof typeof JobOfferApplicationErrorOperationIdEnum];

/**
 * 
 * @export
 * @interface JobOfferCategory
 */
export interface JobOfferCategory {
    /**
     * 
     * @type {number}
     * @memberof JobOfferCategory
     */
    'id': number;
    /**
     * 
     * @type {string}
     * @memberof JobOfferCategory
     */
    'name': string;
}
/**
 * 
 * @export
 * @interface JobOfferCategoryWithOccupations
 */
export interface JobOfferCategoryWithOccupations {
    /**
     * 
     * @type {number}
     * @memberof JobOfferCategoryWithOccupations
     */
    'id'?: number;
    /**
     * 
     * @type {string}
     * @memberof JobOfferCategoryWithOccupations
     */
    'name'?: string;
    /**
     * 
     * @type {Array<JobOfferCategoryWithOccupationsOccupationsInner>}
     * @memberof JobOfferCategoryWithOccupations
     */
    'occupations'?: Array<JobOfferCategoryWithOccupationsOccupationsInner>;
}
/**
 * 
 * @export
 * @interface JobOfferCategoryWithOccupationsOccupationsInner
 */
export interface JobOfferCategoryWithOccupationsOccupationsInner {
    /**
     * 
     * @type {number}
     * @memberof JobOfferCategoryWithOccupationsOccupationsInner
     */
    'id'?: number;
    /**
     * 
     * @type {string}
     * @memberof JobOfferCategoryWithOccupationsOccupationsInner
     */
    'name'?: string;
}
/**
 * 
 * @export
 * @interface JobOfferDetail
 */
export interface JobOfferDetail {
    /**
     * 
     * @type {number}
     * @memberof JobOfferDetail
     */
    'id': number;
    /**
     * 
     * @type {number}
     * @memberof JobOfferDetail
     */
    'jobOfferId': number;
    /**
     * 
     * @type {string}
     * @memberof JobOfferDetail
     */
    'detailedTitle'?: string;
    /**
     * 
     * @type {string}
     * @memberof JobOfferDetail
     */
    'clientName'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof JobOfferDetail
     */
    'workingHours'?: string;
    /**
     * 
     * @type {string}
     * @memberof JobOfferDetail
     */
    'specificWorkContent'?: string;
    /**
     * 
     * @type {string}
     * @memberof JobOfferDetail
     */
    'relatedServicesProducts'?: string;
    /**
     * 
     * @type {string}
     * @memberof JobOfferDetail
     */
    'requirementSkills'?: string;
    /**
     * 
     * @type {string}
     * @memberof JobOfferDetail
     */
    'commercialDistribution'?: string;
    /**
     * 
     * @type {Array<string>}
     * @memberof JobOfferDetail
     */
    'matchingWorkingDays': Array<string>;
    /**
     * 
     * @type {Array<string>}
     * @memberof JobOfferDetail
     */
    'matchingResidentDays': Array<string>;
    /**
     * 
     * @type {Array<string>}
     * @memberof JobOfferDetail
     */
    'developmentLanguages': Array<string>;
    /**
     * 
     * @type {Array<string>}
     * @memberof JobOfferDetail
     */
    'frameworks': Array<string>;
    /**
     * 
     * @type {Array<string>}
     * @memberof JobOfferDetail
     */
    'databases': Array<string>;
    /**
     * 
     * @type {Array<string>}
     * @memberof JobOfferDetail
     */
    'tools': Array<string>;
    /**
     * 
     * @type {Array<string>}
     * @memberof JobOfferDetail
     */
    'infrastructures': Array<string>;
    /**
     * 
     * @type {Array<string>}
     * @memberof JobOfferDetail
     */
    'designs': Array<string>;
    /**
     * 
     * @type {Array<string>}
     * @memberof JobOfferDetail
     */
    'paymentMethods': Array<string>;
}
/**
 * 
 * @export
 * @interface JobOfferMasterSkillsInner
 */
export interface JobOfferMasterSkillsInner {
    /**
     * 
     * @type {string}
     * @memberof JobOfferMasterSkillsInner
     */
    'name': string;
}
/**
 * 案件のスキル
 * @export
 * @interface JobOfferSkill
 */
export interface JobOfferSkill {
    /**
     * 
     * @type {number}
     * @memberof JobOfferSkill
     */
    'id': number;
    /**
     * 
     * @type {string}
     * @memberof JobOfferSkill
     */
    'name': string;
}
/**
 * 
 * @export
 * @interface JobOfferSummary
 */
export interface JobOfferSummary {
    /**
     * 
     * @type {number}
     * @memberof JobOfferSummary
     */
    'id': number;
    /**
     * 
     * @type {string}
     * @memberof JobOfferSummary
     */
    'workStyleName': string;
    /**
     * 
     * @type {string}
     * @memberof JobOfferSummary
     */
    'title': string;
    /**
     * 
     * @type {number}
     * @memberof JobOfferSummary
     */
    'maxUnitPrice': number;
    /**
     * 
     * @type {string}
     * @memberof JobOfferSummary
     */
    'occupationTitle': string;
    /**
     * 
     * @type {string}
     * @memberof JobOfferSummary
     */
    'officeLocation': string;
}
/**
 * 
 * @export
 * @interface MasterSkill
 */
export interface MasterSkill {
    /**
     * 
     * @type {number}
     * @memberof MasterSkill
     */
    'id': number;
    /**
     * 
     * @type {string}
     * @memberof MasterSkill
     */
    'name': string;
}
/**
 * 
 * @export
 * @interface MonthlyWorkReport
 */
export interface MonthlyWorkReport {
    /**
     * 
     * @type {number}
     * @memberof MonthlyWorkReport
     */
    'id'?: number;
    /**
     * 
     * @type {string}
     * @memberof MonthlyWorkReport
     */
    'status'?: string;
    /**
     * 
     * @type {MonthlyWorkReportProjectMonthlyTerm}
     * @memberof MonthlyWorkReport
     */
    'projectMonthlyTerm'?: MonthlyWorkReportProjectMonthlyTerm;
}
/**
 * 
 * @export
 * @interface MonthlyWorkReportDetail
 */
export interface MonthlyWorkReportDetail {
    /**
     * 
     * @type {number}
     * @memberof MonthlyWorkReportDetail
     */
    'id': number;
    /**
     * 
     * @type {string}
     * @memberof MonthlyWorkReportDetail
     */
    'status': string;
    /**
     * 
     * @type {MonthlyWorkReportDetailClientSummary}
     * @memberof MonthlyWorkReportDetail
     */
    'clientSummary': MonthlyWorkReportDetailClientSummary;
    /**
     * 
     * @type {Array<MonthlyWorkReportDetailDailyWorkReportsInner>}
     * @memberof MonthlyWorkReportDetail
     */
    'dailyWorkReports'?: Array<MonthlyWorkReportDetailDailyWorkReportsInner>;
    /**
     * 
     * @type {MonthlyWorkReportDetailProjectMonthlyTerm}
     * @memberof MonthlyWorkReportDetail
     */
    'projectMonthlyTerm': MonthlyWorkReportDetailProjectMonthlyTerm;
}
/**
 * 
 * @export
 * @interface MonthlyWorkReportDetailClientSummary
 */
export interface MonthlyWorkReportDetailClientSummary {
    /**
     * 
     * @type {number}
     * @memberof MonthlyWorkReportDetailClientSummary
     */
    'workingMinutes': number;
}
/**
 * 
 * @export
 * @interface MonthlyWorkReportDetailDailyWorkReportsInner
 */
export interface MonthlyWorkReportDetailDailyWorkReportsInner {
    /**
     * 
     * @type {number}
     * @memberof MonthlyWorkReportDetailDailyWorkReportsInner
     */
    'id': number;
    /**
     * 
     * @type {string}
     * @memberof MonthlyWorkReportDetailDailyWorkReportsInner
     */
    'reportOn': string;
    /**
     * 
     * @type {number}
     * @memberof MonthlyWorkReportDetailDailyWorkReportsInner
     */
    'breaktimeMinutes': number;
    /**
     * 
     * @type {string}
     * @memberof MonthlyWorkReportDetailDailyWorkReportsInner
     */
    'workStartedAt': string;
    /**
     * 
     * @type {string}
     * @memberof MonthlyWorkReportDetailDailyWorkReportsInner
     */
    'workEndedAt': string;
    /**
     * 
     * @type {number}
     * @memberof MonthlyWorkReportDetailDailyWorkReportsInner
     */
    'dayWorkingMinutes': number;
    /**
     * 
     * @type {string}
     * @memberof MonthlyWorkReportDetailDailyWorkReportsInner
     */
    'description': string;
    /**
     * 
     * @type {string}
     * @memberof MonthlyWorkReportDetailDailyWorkReportsInner
     */
    'dailyStatus': string;
}
/**
 * 
 * @export
 * @interface MonthlyWorkReportDetailProjectMonthlyTerm
 */
export interface MonthlyWorkReportDetailProjectMonthlyTerm {
    /**
     * 
     * @type {string}
     * @memberof MonthlyWorkReportDetailProjectMonthlyTerm
     */
    'targetMonth'?: string;
    /**
     * 
     * @type {MonthlyWorkReportDetailProjectMonthlyTermProject}
     * @memberof MonthlyWorkReportDetailProjectMonthlyTerm
     */
    'project'?: MonthlyWorkReportDetailProjectMonthlyTermProject;
}
/**
 * 
 * @export
 * @interface MonthlyWorkReportDetailProjectMonthlyTermProject
 */
export interface MonthlyWorkReportDetailProjectMonthlyTermProject {
    /**
     * 
     * @type {string}
     * @memberof MonthlyWorkReportDetailProjectMonthlyTermProject
     */
    'title': string;
    /**
     * 
     * @type {MonthlyWorkReportProjectMonthlyTermProjectMemberContract}
     * @memberof MonthlyWorkReportDetailProjectMonthlyTermProject
     */
    'memberContract': MonthlyWorkReportProjectMonthlyTermProjectMemberContract;
    /**
     * 
     * @type {BillUser}
     * @memberof MonthlyWorkReportDetailProjectMonthlyTermProject
     */
    'user': BillUser;
}
/**
 * 
 * @export
 * @interface MonthlyWorkReportProjectMonthlyTerm
 */
export interface MonthlyWorkReportProjectMonthlyTerm {
    /**
     * 
     * @type {string}
     * @memberof MonthlyWorkReportProjectMonthlyTerm
     */
    'targetMonth'?: string;
    /**
     * 
     * @type {MonthlyWorkReportProjectMonthlyTermProject}
     * @memberof MonthlyWorkReportProjectMonthlyTerm
     */
    'project'?: MonthlyWorkReportProjectMonthlyTermProject;
}
/**
 * 
 * @export
 * @interface MonthlyWorkReportProjectMonthlyTermProject
 */
export interface MonthlyWorkReportProjectMonthlyTermProject {
    /**
     * 
     * @type {string}
     * @memberof MonthlyWorkReportProjectMonthlyTermProject
     */
    'title': string;
    /**
     * 
     * @type {boolean}
     * @memberof MonthlyWorkReportProjectMonthlyTermProject
     */
    'useWorkReport': boolean;
    /**
     * 
     * @type {MonthlyWorkReportProjectMonthlyTermProjectMemberContract}
     * @memberof MonthlyWorkReportProjectMonthlyTermProject
     */
    'memberContract': MonthlyWorkReportProjectMonthlyTermProjectMemberContract;
    /**
     * 
     * @type {BillUser}
     * @memberof MonthlyWorkReportProjectMonthlyTermProject
     */
    'user': BillUser;
}
/**
 * 
 * @export
 * @interface MonthlyWorkReportProjectMonthlyTermProjectMemberContract
 */
export interface MonthlyWorkReportProjectMonthlyTermProjectMemberContract {
    /**
     * 
     * @type {number}
     * @memberof MonthlyWorkReportProjectMonthlyTermProjectMemberContract
     */
    'minimumWorkingHours': number;
    /**
     * 
     * @type {number}
     * @memberof MonthlyWorkReportProjectMonthlyTermProjectMemberContract
     */
    'maximumWorkingHours': number;
}
/**
 * 404エラー
 * @export
 * @interface NotFoundError
 */
export interface NotFoundError {
    /**
     * 
     * @type {string}
     * @memberof NotFoundError
     */
    'operationId': string;
    /**
     * 
     * @type {string}
     * @memberof NotFoundError
     */
    'error': string;
}
/**
 * 
 * @export
 * @interface PostSearchingBookmark
 */
export interface PostSearchingBookmark {
    /**
     * 
     * @type {string}
     * @memberof PostSearchingBookmark
     */
    'name'?: string;
    /**
     * 
     * @type {string}
     * @memberof PostSearchingBookmark
     */
    'word'?: string;
    /**
     * 
     * @type {number}
     * @memberof PostSearchingBookmark
     */
    'minPrice'?: number;
    /**
     * 
     * @type {number}
     * @memberof PostSearchingBookmark
     */
    'maxPrice'?: number;
    /**
     * 
     * @type {Array<number>}
     * @memberof PostSearchingBookmark
     */
    'workingDays'?: Array<number>;
    /**
     * 
     * @type {Array<number>}
     * @memberof PostSearchingBookmark
     */
    'workStyles'?: Array<number>;
    /**
     * 
     * @type {Array<number>}
     * @memberof PostSearchingBookmark
     */
    'categoryIds'?: Array<number>;
    /**
     * 
     * @type {Array<number>}
     * @memberof PostSearchingBookmark
     */
    'prefectureIds'?: Array<number>;
    /**
     * 
     * @type {Array<number>}
     * @memberof PostSearchingBookmark
     */
    'skillIds'?: Array<number>;
    /**
     * 
     * @type {Array<number>}
     * @memberof PostSearchingBookmark
     */
    'appealIds'?: Array<number>;
}
/**
 * 
 * @export
 * @interface Prefecture
 */
export interface Prefecture {
    /**
     * 
     * @type {number}
     * @memberof Prefecture
     */
    'id': number;
    /**
     * 
     * @type {string}
     * @memberof Prefecture
     */
    'name': string;
}
/**
 * 
 * @export
 * @interface Profile
 */
export interface Profile {
    /**
     * 
     * @type {string}
     * @memberof Profile
     */
    'firstName'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof Profile
     */
    'lastName'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof Profile
     */
    'fullName'?: string;
}
/**
 * 
 * @export
 * @interface QuestionnaireCount
 */
export interface QuestionnaireCount {
    /**
     * 
     * @type {number}
     * @memberof QuestionnaireCount
     */
    'answered'?: number;
    /**
     * 
     * @type {number}
     * @memberof QuestionnaireCount
     */
    'expired'?: number;
    /**
     * 
     * @type {number}
     * @memberof QuestionnaireCount
     */
    'unanswered'?: number;
}
/**
 * 
 * @export
 * @enum {string}
 */

export const QuestionnaireStatus = {
    Unanswered: 'unanswered',
    Expired: 'expired',
    Answered: 'answered'
} as const;

export type QuestionnaireStatus = typeof QuestionnaireStatus[keyof typeof QuestionnaireStatus];


/**
 * 
 * @export
 * @interface QuestionnaireYear
 */
export interface QuestionnaireYear {
    /**
     * 
     * @type {number}
     * @memberof QuestionnaireYear
     */
    'year': number;
    /**
     * 
     * @type {number}
     * @memberof QuestionnaireYear
     */
    'count': number;
}
/**
 * 
 * @export
 * @interface ReferralTokenResponse
 */
export interface ReferralTokenResponse {
    /**
     * 紹介用URLに付与するトークン
     * @type {string}
     * @memberof ReferralTokenResponse
     */
    'token': string;
}
/**
 * 
 * @export
 * @interface SearchingBookmark
 */
export interface SearchingBookmark {
    /**
     * 
     * @type {number}
     * @memberof SearchingBookmark
     */
    'id'?: number;
    /**
     * 
     * @type {string}
     * @memberof SearchingBookmark
     */
    'name'?: string;
    /**
     * 
     * @type {{ [key: string]: string; }}
     * @memberof SearchingBookmark
     */
    'query'?: { [key: string]: string; };
}
/**
 * 
 * @export
 * @interface Seo
 */
export interface Seo {
    /**
     * 
     * @type {string}
     * @memberof Seo
     */
    'theme'?: string;
    /**
     * 
     * @type {string}
     * @memberof Seo
     */
    'title': string;
    /**
     * 
     * @type {string}
     * @memberof Seo
     */
    'description': string;
    /**
     * 
     * @type {string}
     * @memberof Seo
     */
    'breadcrumb': string;
    /**
     * 
     * @type {string}
     * @memberof Seo
     */
    'h1': string;
    /**
     * 
     * @type {string}
     * @memberof Seo
     */
    'prev_url': string | null;
    /**
     * 
     * @type {string}
     * @memberof Seo
     */
    'next_url': string | null;
    /**
     * 
     * @type {string}
     * @memberof Seo
     */
    'canonical_url': string | null;
    /**
     * 
     * @type {SeoContentCategory}
     * @memberof Seo
     */
    'seo_content_category': SeoContentCategory | null;
    /**
     * 
     * @type {SeoContentMasterSkill}
     * @memberof Seo
     */
    'seo_content_master_skill': SeoContentMasterSkill | null;
}
/**
 * 
 * @export
 * @interface SeoContentCategory
 */
export interface SeoContentCategory {
    /**
     * 
     * @type {string}
     * @memberof SeoContentCategory
     */
    'about': string;
    /**
     * 
     * @type {string}
     * @memberof SeoContentCategory
     */
    'required_skill': string;
    /**
     * 
     * @type {Array<ArticlesInformation>}
     * @memberof SeoContentCategory
     */
    'articles'?: Array<ArticlesInformation>;
}
/**
 * 
 * @export
 * @interface SeoContentMasterSkill
 */
export interface SeoContentMasterSkill {
    /**
     * 
     * @type {Array<AboutInformation>}
     * @memberof SeoContentMasterSkill
     */
    'about': Array<AboutInformation>;
    /**
     * 
     * @type {Array<ArticlesInformation>}
     * @memberof SeoContentMasterSkill
     */
    'articles': Array<ArticlesInformation>;
}
/**
 * 
 * @export
 * @interface Skill
 */
export interface Skill {
    /**
     * 
     * @type {number}
     * @memberof Skill
     */
    'id': number;
    /**
     * 
     * @type {string}
     * @memberof Skill
     */
    'skill_name': string;
}
/**
 * 
 * @export
 * @interface SkillCategory
 */
export interface SkillCategory {
    /**
     * 
     * @type {number}
     * @memberof SkillCategory
     */
    'id': number;
    /**
     * 
     * @type {string}
     * @memberof SkillCategory
     */
    'category_name': string;
    /**
     * 
     * @type {Array<SkillType>}
     * @memberof SkillCategory
     */
    'types': Array<SkillType>;
    /**
     * 
     * @type {Array<Skill>}
     * @memberof SkillCategory
     */
    'skills': Array<Skill>;
}
/**
 * 
 * @export
 * @interface SkillType
 */
export interface SkillType {
    /**
     * 
     * @type {number}
     * @memberof SkillType
     */
    'id': number;
    /**
     * 
     * @type {string}
     * @memberof SkillType
     */
    'type_name': string;
    /**
     * 
     * @type {Array<Skill>}
     * @memberof SkillType
     */
    'skills': Array<Skill>;
}
/**
 * 
 * @export
 * @interface TodoList
 */
export interface TodoList {
    /**
     * 
     * @type {boolean}
     * @memberof TodoList
     */
    'visible': boolean;
    /**
     * 
     * @type {number}
     * @memberof TodoList
     */
    'remainingCount': number;
    /**
     * 
     * @type {boolean}
     * @memberof TodoList
     */
    'workPreferenceCompleted': boolean;
    /**
     * 
     * @type {boolean}
     * @memberof TodoList
     */
    'jobOfferApplicationCompleted': boolean;
    /**
     * 
     * @type {boolean}
     * @memberof TodoList
     */
    'jobOfferApplicationRecommended': boolean;
    /**
     * 
     * @type {boolean}
     * @memberof TodoList
     */
    'resumeCompleted': boolean;
}
/**
 * ログインエラー(401)
 * @export
 * @interface UnauthorizedError
 */
export interface UnauthorizedError {
    /**
     * 
     * @type {string}
     * @memberof UnauthorizedError
     */
    'operationId': string;
    /**
     * 
     * @type {string}
     * @memberof UnauthorizedError
     */
    'error': string;
}
/**
 * 
 * @export
 * @interface UnprocessableEntityError
 */
export interface UnprocessableEntityError {
    /**
     * 
     * @type {string}
     * @memberof UnprocessableEntityError
     */
    'operationId': string;
    /**
     * 
     * @type {string}
     * @memberof UnprocessableEntityError
     */
    'message'?: string;
    /**
     * 
     * @type {PostSearchingBookmark}
     * @memberof UnprocessableEntityError
     */
    'searchingBookmark'?: PostSearchingBookmark;
}
/**
 * 
 * @export
 * @interface UpdateClientContractExtensionRequest
 */
export interface UpdateClientContractExtensionRequest {
    /**
     * 
     * @type {UpdateContractExtensionRequest}
     * @memberof UpdateClientContractExtensionRequest
     */
    'contractExtensionRequest'?: UpdateContractExtensionRequest;
}
/**
 * 
 * @export
 * @interface UpdateClientStaffPassword200Response
 */
export interface UpdateClientStaffPassword200Response {
    /**
     * 
     * @type {string}
     * @memberof UpdateClientStaffPassword200Response
     */
    'message': string;
}
/**
 * パスワード変更エラー
 * @export
 * @interface UpdateClientStaffPasswordBadRequest
 */
export interface UpdateClientStaffPasswordBadRequest {
    /**
     * 
     * @type {string}
     * @memberof UpdateClientStaffPasswordBadRequest
     */
    'operationId': UpdateClientStaffPasswordBadRequestOperationIdEnum;
    /**
     * 
     * @type {UpdateClientStaffPasswordBadRequestErrors}
     * @memberof UpdateClientStaffPasswordBadRequest
     */
    'errors': UpdateClientStaffPasswordBadRequestErrors;
}

export const UpdateClientStaffPasswordBadRequestOperationIdEnum = {
    UpdateClientStaffPassword: 'updateClientStaffPassword'
} as const;

export type UpdateClientStaffPasswordBadRequestOperationIdEnum = typeof UpdateClientStaffPasswordBadRequestOperationIdEnum[keyof typeof UpdateClientStaffPasswordBadRequestOperationIdEnum];

/**
 * 
 * @export
 * @interface UpdateClientStaffPasswordBadRequestErrors
 */
export interface UpdateClientStaffPasswordBadRequestErrors {
    /**
     * 
     * @type {Array<string>}
     * @memberof UpdateClientStaffPasswordBadRequestErrors
     */
    'password'?: Array<string>;
    /**
     * 
     * @type {Array<string>}
     * @memberof UpdateClientStaffPasswordBadRequestErrors
     */
    'passwordConfirmation'?: Array<string>;
}
/**
 * 
 * @export
 * @interface UpdateClientStaffPasswordRequest
 */
export interface UpdateClientStaffPasswordRequest {
    /**
     * 
     * @type {string}
     * @memberof UpdateClientStaffPasswordRequest
     */
    'password': string;
    /**
     * 
     * @type {string}
     * @memberof UpdateClientStaffPasswordRequest
     */
    'passwordConfirmation': string;
}
/**
 * 
 * @export
 * @interface UpdateContractExtensionRequest
 */
export interface UpdateContractExtensionRequest {
    /**
     * 
     * @type {{ [key: string]: UpdateExtensionSurveyAnswerValue; }}
     * @memberof UpdateContractExtensionRequest
     */
    'extensionSurveyAnswers'?: { [key: string]: UpdateExtensionSurveyAnswerValue; };
    /**
     * 
     * @type {UpdateOutsourcingChecked}
     * @memberof UpdateContractExtensionRequest
     */
    'outsourcingChecked'?: UpdateOutsourcingChecked;
}


/**
 * 
 * @export
 * @interface UpdateExtensionSurveyAnswerValue
 */
export interface UpdateExtensionSurveyAnswerValue {
    /**
     * 
     * @type {number}
     * @memberof UpdateExtensionSurveyAnswerValue
     */
    'id'?: number;
    /**
     * 
     * @type {number}
     * @memberof UpdateExtensionSurveyAnswerValue
     */
    'question_id'?: number;
    /**
     * 
     * @type {string}
     * @memberof UpdateExtensionSurveyAnswerValue
     */
    'answer'?: string;
}
/**
 * 
 * @export
 * @enum {number}
 */

export const UpdateOutsourcingChecked = {
    NUMBER_0: 0,
    NUMBER_1: 1
} as const;

export type UpdateOutsourcingChecked = typeof UpdateOutsourcingChecked[keyof typeof UpdateOutsourcingChecked];


/**
 * 
 * @export
 * @interface UpdateUserSkillRelations422Response
 */
export interface UpdateUserSkillRelations422Response {
    /**
     * 
     * @type {string}
     * @memberof UpdateUserSkillRelations422Response
     */
    'operationId': string;
    /**
     * 
     * @type {string}
     * @memberof UpdateUserSkillRelations422Response
     */
    'error': string;
}
/**
 * 
 * @export
 * @interface UpdateUserSkillRelationsRequest
 */
export interface UpdateUserSkillRelationsRequest {
    /**
     * 
     * @type {Array<UserSkillRelation>}
     * @memberof UpdateUserSkillRelationsRequest
     */
    'userSkillRelations'?: Array<UserSkillRelation>;
}
/**
 * メンバーログインエラー(401)
 * @export
 * @interface UserAuthUnauthorizedError
 */
export interface UserAuthUnauthorizedError {
    /**
     * 
     * @type {string}
     * @memberof UserAuthUnauthorizedError
     */
    'operationId': string;
    /**
     * 
     * @type {string}
     * @memberof UserAuthUnauthorizedError
     */
    'error': string;
    /**
     * 
     * @type {string}
     * @memberof UserAuthUnauthorizedError
     */
    'code': UserAuthUnauthorizedErrorCodeEnum;
}

export const UserAuthUnauthorizedErrorCodeEnum = {
    InvalidCredentials: 'INVALID_CREDENTIALS',
    PasswordLockImminent: 'PASSWORD_LOCK_IMMINENT',
    AccountLockedJustNow: 'ACCOUNT_LOCKED_JUST_NOW',
    AccountLocked: 'ACCOUNT_LOCKED'
} as const;

export type UserAuthUnauthorizedErrorCodeEnum = typeof UserAuthUnauthorizedErrorCodeEnum[keyof typeof UserAuthUnauthorizedErrorCodeEnum];

/**
 * 
 * @export
 * @interface UserEvaluation
 */
export interface UserEvaluation {
    /**
     * 
     * @type {string}
     * @memberof UserEvaluation
     */
    'title': string;
    /**
     * 
     * @type {number}
     * @memberof UserEvaluation
     */
    'percent': number;
}
/**
 * 案件情報
 * @export
 * @interface UserJobOffer
 */
export interface UserJobOffer {
    /**
     * 
     * @type {number}
     * @memberof UserJobOffer
     */
    'id': number;
    /**
     * 案件が募集中かどうか
     * @type {boolean}
     * @memberof UserJobOffer
     */
    'open': boolean;
    /**
     * 新着案件フラグ
     * @type {boolean}
     * @memberof UserJobOffer
     */
    'new': boolean;
    /**
     * 案件名
     * @type {string}
     * @memberof UserJobOffer
     */
    'title': string;
    /**
     * 最高月額単価
     * @type {number}
     * @memberof UserJobOffer
     */
    'maxUnitPrice': number | null;
    /**
     * 業務内容
     * @type {string}
     * @memberof UserJobOffer
     */
    'description': string;
    /**
     * オフィス所在地
     * @type {string}
     * @memberof UserJobOffer
     */
    'officeLocation'?: string;
    /**
     * 最低稼働日数
     * @type {number}
     * @memberof UserJobOffer
     */
    'requiredWorkingDays'?: number;
    /**
     * 
     * @type {UserJobOfferOccupation}
     * @memberof UserJobOffer
     */
    'occupation': UserJobOfferOccupation;
    /**
     * テック掲載スキル（1〜3）のリスト
     * @type {Array<JobOfferSkill>}
     * @memberof UserJobOffer
     */
    'skills'?: Array<JobOfferSkill>;
    /**
     * こだわりのリスト
     * @type {Array<UserJobOfferAppealsInner>}
     * @memberof UserJobOffer
     */
    'appeals'?: Array<UserJobOfferAppealsInner>;
}
/**
 * 
 * @export
 * @interface UserJobOfferAppealsInner
 */
export interface UserJobOfferAppealsInner {
    /**
     * 
     * @type {number}
     * @memberof UserJobOfferAppealsInner
     */
    'id'?: number;
    /**
     * 
     * @type {string}
     * @memberof UserJobOfferAppealsInner
     */
    'description'?: string;
}
/**
 * 職種
 * @export
 * @interface UserJobOfferOccupation
 */
export interface UserJobOfferOccupation {
    /**
     * 
     * @type {number}
     * @memberof UserJobOfferOccupation
     */
    'id'?: number;
    /**
     * 
     * @type {string}
     * @memberof UserJobOfferOccupation
     */
    'name'?: string;
}
/**
 * 
 * @export
 * @interface UserLogin200Response
 */
export interface UserLogin200Response {
    /**
     * 
     * @type {number}
     * @memberof UserLogin200Response
     */
    'id': number;
    /**
     * 
     * @type {string}
     * @memberof UserLogin200Response
     */
    'nextPath': string;
}
/**
 * 
 * @export
 * @interface UserLoginRequest
 */
export interface UserLoginRequest {
    /**
     * 
     * @type {ClientLoginRequest}
     * @memberof UserLoginRequest
     */
    'auth': ClientLoginRequest;
}
/**
 * 
 * @export
 * @interface UserSkillRelation
 */
export interface UserSkillRelation {
    /**
     * 
     * @type {number}
     * @memberof UserSkillRelation
     */
    'masterSkillId'?: number;
    /**
     * 
     * @type {number}
     * @memberof UserSkillRelation
     */
    'year'?: number;
    /**
     * 
     * @type {boolean}
     * @memberof UserSkillRelation
     */
    'isFocusSkill'?: boolean;
}
/**
 * バリデーションエラー
 * @export
 * @interface ValidationError
 */
export interface ValidationError {
    /**
     * 
     * @type {string}
     * @memberof ValidationError
     */
    'operationId': string;
    /**
     * 
     * @type {string}
     * @memberof ValidationError
     */
    'error': string;
}
/**
 * バリデーションエラーのレスポンス（例: {\"operationId\": \"createUserReferral\", \"errors\": {\"email\": [\"メールアドレスを入力してください。\", \"メールアドレスが正しくありません。\"]}}）
 * @export
 * @interface ValidationError1
 */
export interface ValidationError1 {
    /**
     * リクエストのoperationId（例: createUserReferral）
     * @type {string}
     * @memberof ValidationError1
     */
    'operationId': string;
    /**
     * 各フィールド名をキー、値はエラーメッセージの配列
     * @type {{ [key: string]: Array<string>; }}
     * @memberof ValidationError1
     */
    'errors': { [key: string]: Array<string>; };
}
/**
 * 
 * @export
 * @interface VerifyClientStaffEmail200Response
 */
export interface VerifyClientStaffEmail200Response {
    /**
     * 
     * @type {string}
     * @memberof VerifyClientStaffEmail200Response
     */
    'message'?: string;
}
/**
 * メールアドレス認証エラー
 * @export
 * @interface VerifyClientStaffEmailBadRequest
 */
export interface VerifyClientStaffEmailBadRequest {
    /**
     * 
     * @type {string}
     * @memberof VerifyClientStaffEmailBadRequest
     */
    'operationId': VerifyClientStaffEmailBadRequestOperationIdEnum;
    /**
     * 
     * @type {string}
     * @memberof VerifyClientStaffEmailBadRequest
     */
    'error': string;
}

export const VerifyClientStaffEmailBadRequestOperationIdEnum = {
    VerifyClientStaffEmail: 'verifyClientStaffEmail'
} as const;

export type VerifyClientStaffEmailBadRequestOperationIdEnum = typeof VerifyClientStaffEmailBadRequestOperationIdEnum[keyof typeof VerifyClientStaffEmailBadRequestOperationIdEnum];

/**
 * 
 * @export
 * @interface VerifyClientStaffEmailRequest
 */
export interface VerifyClientStaffEmailRequest {
    /**
     * 
     * @type {string}
     * @memberof VerifyClientStaffEmailRequest
     */
    'email': string;
    /**
     * 
     * @type {boolean}
     * @memberof VerifyClientStaffEmailRequest
     */
    'agreePrivacyPolicy': boolean;
}
/**
 * 
 * @export
 * @interface WorkPreference
 */
export interface WorkPreference {
    /**
     * 
     * @type {string}
     * @memberof WorkPreference
     */
    'start_date'?: string;
    /**
     * 
     * @type {number}
     * @memberof WorkPreference
     */
    'min_work_hours_per_week'?: number;
    /**
     * Must be greater than or equal to `min_work_hours_per_week`. 
     * @type {number}
     * @memberof WorkPreference
     */
    'max_work_hours_per_week'?: number;
    /**
     * 
     * @type {Array<number>}
     * @memberof WorkPreference
     */
    'work_days_of_week'?: Array<number>;
    /**
     * 
     * @type {Array<number>}
     * @memberof WorkPreference
     */
    'office_days_of_week'?: Array<number>;
    /**
     * 
     * @type {string}
     * @memberof WorkPreference
     */
    'remote_work_preference'?: WorkPreferenceRemoteWorkPreferenceEnum;
    /**
     * 
     * @type {string}
     * @memberof WorkPreference
     */
    'available_time'?: WorkPreferenceAvailableTimeEnum;
    /**
     * 
     * @type {number}
     * @memberof WorkPreference
     */
    'desired_monthly_salary'?: number;
    /**
     * 
     * @type {string}
     * @memberof WorkPreference
     */
    'additional_conditions'?: string;
    /**
     * 
     * @type {boolean}
     * @memberof WorkPreference
     */
    'full_time_job_introduction'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof WorkPreference
     */
    'temp_job_introduction'?: boolean;
    /**
     * 
     * @type {string}
     * @memberof WorkPreference
     */
    'pre_communication_notes'?: string;
    /**
     * 
     * @type {string}
     * @memberof WorkPreference
     */
    'excluded_companies'?: string;
    /**
     * 
     * @type {boolean}
     * @memberof WorkPreference
     */
    'work_from_abroad'?: boolean;
}

export const WorkPreferenceRemoteWorkPreferenceEnum = {
    Flexible: 'flexible',
    OnboardingOnly: 'onboarding_only',
    FullyRemote: 'fully_remote'
} as const;

export type WorkPreferenceRemoteWorkPreferenceEnum = typeof WorkPreferenceRemoteWorkPreferenceEnum[keyof typeof WorkPreferenceRemoteWorkPreferenceEnum];
export const WorkPreferenceAvailableTimeEnum = {
    WeekdayDaytime: 'weekday_daytime',
    EveningOrWeekendMtgFlexible: 'evening_or_weekend_mtg_flexible',
    EveningOrWeekend: 'evening_or_weekend'
} as const;

export type WorkPreferenceAvailableTimeEnum = typeof WorkPreferenceAvailableTimeEnum[keyof typeof WorkPreferenceAvailableTimeEnum];

/**
 * 
 * @export
 * @interface WorkPreferenceForm
 */
export interface WorkPreferenceForm {
    /**
     * 
     * @type {string}
     * @memberof WorkPreferenceForm
     */
    'start_date'?: string;
    /**
     * 
     * @type {number}
     * @memberof WorkPreferenceForm
     */
    'min_work_hours_per_week'?: number;
    /**
     * Must be greater than or equal to `min_work_hours_per_week`. 
     * @type {number}
     * @memberof WorkPreferenceForm
     */
    'max_work_hours_per_week'?: number;
    /**
     * 
     * @type {Array<number>}
     * @memberof WorkPreferenceForm
     */
    'work_days_of_week'?: Array<number>;
    /**
     * 
     * @type {Array<number>}
     * @memberof WorkPreferenceForm
     */
    'office_days_of_week'?: Array<number>;
    /**
     * 
     * @type {string}
     * @memberof WorkPreferenceForm
     */
    'remote_work_preference'?: WorkPreferenceFormRemoteWorkPreferenceEnum;
    /**
     * 
     * @type {string}
     * @memberof WorkPreferenceForm
     */
    'available_time'?: WorkPreferenceFormAvailableTimeEnum;
    /**
     * 
     * @type {number}
     * @memberof WorkPreferenceForm
     */
    'desired_monthly_salary'?: number;
    /**
     * 
     * @type {string}
     * @memberof WorkPreferenceForm
     */
    'additional_conditions'?: string;
    /**
     * 
     * @type {boolean}
     * @memberof WorkPreferenceForm
     */
    'full_time_job_introduction'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof WorkPreferenceForm
     */
    'temp_job_introduction'?: boolean;
    /**
     * 
     * @type {string}
     * @memberof WorkPreferenceForm
     */
    'pre_communication_notes'?: string;
    /**
     * 
     * @type {string}
     * @memberof WorkPreferenceForm
     */
    'excluded_companies'?: string;
    /**
     * 
     * @type {boolean}
     * @memberof WorkPreferenceForm
     */
    'work_from_abroad'?: boolean;
    /**
     * 
     * @type {string}
     * @memberof WorkPreferenceForm
     */
    'form_group'?: WorkPreferenceFormFormGroupEnum;
}

export const WorkPreferenceFormRemoteWorkPreferenceEnum = {
    Flexible: 'flexible',
    OnboardingOnly: 'onboarding_only',
    FullyRemote: 'fully_remote'
} as const;

export type WorkPreferenceFormRemoteWorkPreferenceEnum = typeof WorkPreferenceFormRemoteWorkPreferenceEnum[keyof typeof WorkPreferenceFormRemoteWorkPreferenceEnum];
export const WorkPreferenceFormAvailableTimeEnum = {
    WeekdayDaytime: 'weekday_daytime',
    EveningOrWeekendMtgFlexible: 'evening_or_weekend_mtg_flexible',
    EveningOrWeekend: 'evening_or_weekend'
} as const;

export type WorkPreferenceFormAvailableTimeEnum = typeof WorkPreferenceFormAvailableTimeEnum[keyof typeof WorkPreferenceFormAvailableTimeEnum];
export const WorkPreferenceFormFormGroupEnum = {
    CurrentSituation: 'current_situation',
    JobOfferPreference: 'job_offer_preference',
    AdditionalPreferences: 'additional_preferences',
    AllFields: 'all_fields'
} as const;

export type WorkPreferenceFormFormGroupEnum = typeof WorkPreferenceFormFormGroupEnum[keyof typeof WorkPreferenceFormFormGroupEnum];


/**
 * V1Api - axios parameter creator
 * @export
 */
export const V1ApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary list featured job offers for TOP page
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1UsersTopFeaturedJobOffersGet: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/users/top/featured_job_offers`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary list information for TOP page
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1UsersTopInformationGet: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/users/top/information`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary list job offer search categories for TOP page
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1UsersTopJobOfferSearchCategoriesGet: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/users/top/job_offer_search/categories`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary list job offer search master skills for TOP page
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1UsersTopJobOfferSearchMasterSkillsGet: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/users/top/job_offer_search/master_skills`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * クライアントのメールアドレスとパスワードでログインをする
         * @summary create authenticate token
         * @param {ClientLoginRequest} [clientLoginRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        clientLogin: async (clientLoginRequest?: ClientLoginRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/clients/auths`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(clientLoginRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * クライアントをログアウトさせる
         * @summary delete authenticate token
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        clientLogout: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/clients/auths`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary initial invoice information
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createInitialInvoiceInformation: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/users/invoice_informations`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication csrfToken required
            await setApiKeyToObject(localVarHeaderParameter, "X-CSRF-TOKEN", configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary create invoice number
         * @param {CreateInvoiceNumberRequest} [createInvoiceNumberRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createInvoiceNumber: async (createInvoiceNumberRequest?: CreateInvoiceNumberRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/users/invoice_numbers`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication csrfToken required
            await setApiKeyToObject(localVarHeaderParameter, "X-CSRF-TOKEN", configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(createInvoiceNumberRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary create job offer application
         * @param {number} jobOfferId 
         * @param {CreateJobOfferApplicationRequest} createJobOfferApplicationRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createJobOfferApplication: async (jobOfferId: number, createJobOfferApplicationRequest: CreateJobOfferApplicationRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'jobOfferId' is not null or undefined
            assertParamExists('createJobOfferApplication', 'jobOfferId', jobOfferId)
            // verify required parameter 'createJobOfferApplicationRequest' is not null or undefined
            assertParamExists('createJobOfferApplication', 'createJobOfferApplicationRequest', createJobOfferApplicationRequest)
            const localVarPath = `/api/v1/users/job_offers/{job_offer_id}/application`
                .replace(`{${"job_offer_id"}}`, encodeURIComponent(String(jobOfferId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication csrfToken required
            await setApiKeyToObject(localVarHeaderParameter, "X-CSRF-TOKEN", configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(createJobOfferApplicationRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 紹介用URLのトークンを使用して新しいユーザー登録と紹介を作成する
         * @summary Create a new referral
         * @param {CreateUserReferralRequest} createUserReferralRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createUserReferral: async (createUserReferralRequest: CreateUserReferralRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'createUserReferralRequest' is not null or undefined
            assertParamExists('createUserReferral', 'createUserReferralRequest', createUserReferralRequest)
            const localVarPath = `/api/v1/users/referrals`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication csrfToken required
            await setApiKeyToObject(localVarHeaderParameter, "X-CSRF-TOKEN", configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(createUserReferralRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 検索条件を保存する
         * @summary create searching bookmark
         * @param {PostSearchingBookmark} [postSearchingBookmark] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createUserSearchingBookmark: async (postSearchingBookmark?: PostSearchingBookmark, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/users/searching_bookmarks`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication csrfToken required
            await setApiKeyToObject(localVarHeaderParameter, "X-CSRF-TOKEN", configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(postSearchingBookmark, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 検索履歴を保存する
         * @summary create searching history
         * @param {CreateUserSearchingHistoryRequest} [createUserSearchingHistoryRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createUserSearchingHistory: async (createUserSearchingHistoryRequest?: CreateUserSearchingHistoryRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/users/searching_histories`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication csrfToken required
            await setApiKeyToObject(localVarHeaderParameter, "X-CSRF-TOKEN", configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(createUserSearchingHistoryRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary delete job offers favorite
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteJobOffersFavorite: async (id: number, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('deleteJobOffersFavorite', 'id', id)
            const localVarPath = `/api/v1/users/job_offers/favorites/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication csrfToken required
            await setApiKeyToObject(localVarHeaderParameter, "X-CSRF-TOKEN", configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 掲載案件候補一覧を取得する
         * @summary list job offers
         * @param {string} [salesforceJobId] 
         * @param {string} [order] 
         * @param {number} [limit] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAdminJobOffers: async (salesforceJobId?: string, order?: string, limit?: number, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/admin/job_offers`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (salesforceJobId !== undefined) {
                localVarQueryParameter['salesforce_job_id'] = salesforceJobId;
            }

            if (order !== undefined) {
                localVarQueryParameter['order'] = order;
            }

            if (limit !== undefined) {
                localVarQueryParameter['limit'] = limit;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary list appeals
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAppeals: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/users/job_offers/appeals`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * クライアント請求詳細を取得する。
         * @summary show
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getClientBill: async (id: number, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('getClientBill', 'id', id)
            const localVarPath = `/api/v1/clients/bills/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * クライアントのステータス別請求数を取得する
         * @summary get client bill count per bill status
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getClientBillCount: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/clients/bills/count`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * クライアント請求書のPDFを取得する
         * @summary get client ledger sheet
         * @param {number} billId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getClientBillLedgerSheet: async (billId: number, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'billId' is not null or undefined
            assertParamExists('getClientBillLedgerSheet', 'billId', billId)
            const localVarPath = `/api/v1/clients/bills/{bill_id}/ledger_sheet`
                .replace(`{${"bill_id"}}`, encodeURIComponent(String(billId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * クライアントの請求年一覧を取得する
         * @summary list bill accounting years
         * @param {GetClientBillYearsOrderEnum} [order] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getClientBillYears: async (order?: GetClientBillYearsOrderEnum, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/clients/bills/years`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (order !== undefined) {
                localVarQueryParameter['order'] = order;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary index
         * @param {GetClientBillsStatusEnum} [status] 
         * @param {string} [targetYear] 
         * @param {string} [targetMonth] 
         * @param {GetClientBillsOrderEnum} [order] 
         * @param {GetClientBillsDirectionEnum} [direction] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getClientBills: async (status?: GetClientBillsStatusEnum, targetYear?: string, targetMonth?: string, order?: GetClientBillsOrderEnum, direction?: GetClientBillsDirectionEnum, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/clients/bills`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (status !== undefined) {
                localVarQueryParameter['status'] = status;
            }

            if (targetYear !== undefined) {
                localVarQueryParameter['targetYear'] = targetYear;
            }

            if (targetMonth !== undefined) {
                localVarQueryParameter['targetMonth'] = targetMonth;
            }

            if (order !== undefined) {
                localVarQueryParameter['order'] = order;
            }

            if (direction !== undefined) {
                localVarQueryParameter['direction'] = direction;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary get client contract extension request
         * @param {string} accessToken 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getClientContractExtensionRequest: async (accessToken: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'accessToken' is not null or undefined
            assertParamExists('getClientContractExtensionRequest', 'accessToken', accessToken)
            const localVarPath = `/api/v1/clients/contract_extension_requests/{access_token}`
                .replace(`{${"access_token"}}`, encodeURIComponent(String(accessToken)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * クライアントに紐づく月次作業報告詳細を取得する
         * @summary show
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getClientMonthlyWorkReport: async (id: number, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('getClientMonthlyWorkReport', 'id', id)
            const localVarPath = `/api/v1/clients/monthly_work_reports/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary index
         * @param {number} [page] ページ番号
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getClientMonthlyWorkReports: async (page?: number, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/clients/monthly_work_reports`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (page !== undefined) {
                localVarQueryParameter['page'] = page;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * クライアントのアンケート件数を取得する
         * @summary get count of client questionnaires
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getClientQuestionnaireCount: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/clients/questionnaires/count`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * クライアントのアンケート作成年一覧を取得する
         * @summary list years of client questionnaires
         * @param {GetClientQuestionnaireYearsOrderEnum} [order] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getClientQuestionnaireYears: async (order?: GetClientQuestionnaireYearsOrderEnum, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/clients/questionnaires/years`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (order !== undefined) {
                localVarQueryParameter['order'] = order;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 契約更新の確認一覧を取得する
         * @summary index
         * @param {number} [page] 
         * @param {GetClientQuestionnairesStatusEnum} [status] 
         * @param {GetClientQuestionnairesOrderEnum} [order] 
         * @param {GetClientQuestionnairesDirectionEnum} [direction] 
         * @param {string} [targetYear] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getClientQuestionnaires: async (page?: number, status?: GetClientQuestionnairesStatusEnum, order?: GetClientQuestionnairesOrderEnum, direction?: GetClientQuestionnairesDirectionEnum, targetYear?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/clients/questionnaires`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (page !== undefined) {
                localVarQueryParameter['page'] = page;
            }

            if (status !== undefined) {
                localVarQueryParameter['status'] = status;
            }

            if (order !== undefined) {
                localVarQueryParameter['order'] = order;
            }

            if (direction !== undefined) {
                localVarQueryParameter['direction'] = direction;
            }

            if (targetYear !== undefined) {
                localVarQueryParameter['targetYear'] = targetYear;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary get evaluations
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getEvaluations: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/users/evaluations`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary list job offer categories with occupations
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getJobOfferCategoriesOccupations: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/users/job_offer_categories/occupations`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary list categories
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getJobOffersCategories: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/users/job_offers/categories`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary job offers seo
         * @param {Array<number>} [categoryIds] 
         * @param {Array<number>} [skillIds] 
         * @param {number} [page] 
         * @param {Array<number>} [prefectureIds] 
         * @param {string} [searchWord] 
         * @param {Array<number>} [workingDayIds] 
         * @param {Array<number>} [workStyleIds] 
         * @param {Array<number>} [appealIds] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getJobOffersSeo: async (categoryIds?: Array<number>, skillIds?: Array<number>, page?: number, prefectureIds?: Array<number>, searchWord?: string, workingDayIds?: Array<number>, workStyleIds?: Array<number>, appealIds?: Array<number>, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/users/job_offers/seo`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (categoryIds) {
                localVarQueryParameter['category_ids'] = categoryIds.join(COLLECTION_FORMATS.csv);
            }

            if (skillIds) {
                localVarQueryParameter['skill_ids'] = skillIds.join(COLLECTION_FORMATS.csv);
            }

            if (page !== undefined) {
                localVarQueryParameter['page'] = page;
            }

            if (prefectureIds) {
                localVarQueryParameter['prefecture_ids'] = prefectureIds.join(COLLECTION_FORMATS.csv);
            }

            if (searchWord !== undefined) {
                localVarQueryParameter['search_word'] = searchWord;
            }

            if (workingDayIds) {
                localVarQueryParameter['working_day_ids'] = workingDayIds.join(COLLECTION_FORMATS.csv);
            }

            if (workStyleIds) {
                localVarQueryParameter['work_style_ids'] = workStyleIds.join(COLLECTION_FORMATS.csv);
            }

            if (appealIds) {
                localVarQueryParameter['appeal_ids'] = appealIds.join(COLLECTION_FORMATS.csv);
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary list prefectures
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getPrefectures: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/users/prefectures`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary list recommended categories
         * @param {Array<string>} [categoryIds] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getRecommendedCategories: async (categoryIds?: Array<string>, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/users/job_offers/recommended_categories`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (categoryIds) {
                localVarQueryParameter['category_ids'] = categoryIds.join(COLLECTION_FORMATS.csv);
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary list recommended skills
         * @param {Array<string>} [categoryIds] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getRecommendedSkills: async (categoryIds?: Array<string>, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/users/job_offers/recommended_skills`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (categoryIds) {
                localVarQueryParameter['category_ids'] = categoryIds.join(COLLECTION_FORMATS.csv);
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 紹介者ページで紹介トークンを取得する
         * @summary get referral token
         * @param {string} token 紹介トークン
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getReferralToken: async (token: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'token' is not null or undefined
            assertParamExists('getReferralToken', 'token', token)
            const localVarPath = `/api/v1/users/referral_tokens/{token}`
                .replace(`{${"token"}}`, encodeURIComponent(String(token)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary list skill_categories
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getSkillCategories: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/users/job_offers/skill_categories`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary 本人確認用の住所情報を取得する
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getUserIdentifyVerificationAddress: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/users/identify_verification_address`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary job offer detail
         * @param {number} jobOfferId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getUserJobOfferDetail: async (jobOfferId: number, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'jobOfferId' is not null or undefined
            assertParamExists('getUserJobOfferDetail', 'jobOfferId', jobOfferId)
            const localVarPath = `/api/v1/users/job_offers/{job_offer_id}/detail`
                .replace(`{${"job_offer_id"}}`, encodeURIComponent(String(jobOfferId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary get job offer summary
         * @param {number} jobOfferId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getUserJobOfferSummary: async (jobOfferId: number, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'jobOfferId' is not null or undefined
            assertParamExists('getUserJobOfferSummary', 'jobOfferId', jobOfferId)
            const localVarPath = `/api/v1/users/job_offer_summary/{job_offer_id}`
                .replace(`{${"job_offer_id"}}`, encodeURIComponent(String(jobOfferId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary list job offers
         * @param {string} [word] 検索キーワード
         * @param {number} [minPrice] 単価下限
         * @param {number} [maxPrice] 単価上限
         * @param {boolean} [openonly] 募集中のみ表示するかどうか
         * @param {Array<number>} [workingDays] 稼働日数
         * @param {Array<number>} [workStyles] 稼働形態
         * @param {Array<number>} [categoryIds] 職種カテゴリIDのリスト
         * @param {Array<number>} [prefectureIds] エリア(都道府県)IDのリスト
         * @param {Array<number>} [skillIds] スキルIDのリスト
         * @param {Array<number>} [appealIds] こだわりIDのリスト
         * @param {GetUserJobOffersOrderEnum} [order] ソート順
         * @param {number} [page] ページ番号
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getUserJobOffers: async (word?: string, minPrice?: number, maxPrice?: number, openonly?: boolean, workingDays?: Array<number>, workStyles?: Array<number>, categoryIds?: Array<number>, prefectureIds?: Array<number>, skillIds?: Array<number>, appealIds?: Array<number>, order?: GetUserJobOffersOrderEnum, page?: number, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/users/job_offers`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (word !== undefined) {
                localVarQueryParameter['word'] = word;
            }

            if (minPrice !== undefined) {
                localVarQueryParameter['min_price'] = minPrice;
            }

            if (maxPrice !== undefined) {
                localVarQueryParameter['max_price'] = maxPrice;
            }

            if (openonly !== undefined) {
                localVarQueryParameter['openonly'] = openonly;
            }

            if (workingDays) {
                localVarQueryParameter['working_days[]'] = workingDays.join(COLLECTION_FORMATS.csv);
            }

            if (workStyles) {
                localVarQueryParameter['work_styles[]'] = workStyles.join(COLLECTION_FORMATS.csv);
            }

            if (categoryIds) {
                localVarQueryParameter['category_ids[]'] = categoryIds.join(COLLECTION_FORMATS.csv);
            }

            if (prefectureIds) {
                localVarQueryParameter['prefecture_ids[]'] = prefectureIds.join(COLLECTION_FORMATS.csv);
            }

            if (skillIds) {
                localVarQueryParameter['skill_ids[]'] = skillIds.join(COLLECTION_FORMATS.csv);
            }

            if (appealIds) {
                localVarQueryParameter['appeal_ids[]'] = appealIds.join(COLLECTION_FORMATS.csv);
            }

            if (order !== undefined) {
                localVarQueryParameter['order'] = order;
            }

            if (page !== undefined) {
                localVarQueryParameter['page'] = page;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary get job offers count
         * @param {string} [word] 検索キーワード
         * @param {number} [minPrice] 単価下限
         * @param {number} [maxPrice] 単価上限
         * @param {boolean} [openonly] 募集中のみ表示するかどうか
         * @param {Array<number>} [workingDays] 稼働日数
         * @param {Array<number>} [workStyles] 稼働形態
         * @param {Array<number>} [categoryIds] 職種カテゴリIDのリスト
         * @param {Array<number>} [prefectureIds] エリア(都道府県)IDのリスト
         * @param {Array<number>} [skillIds] スキルIDのリスト
         * @param {Array<number>} [appealIds] こだわりIDのリスト
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getUserJobOffersCount: async (word?: string, minPrice?: number, maxPrice?: number, openonly?: boolean, workingDays?: Array<number>, workStyles?: Array<number>, categoryIds?: Array<number>, prefectureIds?: Array<number>, skillIds?: Array<number>, appealIds?: Array<number>, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/users/job_offers/count`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (word !== undefined) {
                localVarQueryParameter['word'] = word;
            }

            if (minPrice !== undefined) {
                localVarQueryParameter['min_price'] = minPrice;
            }

            if (maxPrice !== undefined) {
                localVarQueryParameter['max_price'] = maxPrice;
            }

            if (openonly !== undefined) {
                localVarQueryParameter['openonly'] = openonly;
            }

            if (workingDays) {
                localVarQueryParameter['working_days[]'] = workingDays.join(COLLECTION_FORMATS.csv);
            }

            if (workStyles) {
                localVarQueryParameter['work_styles[]'] = workStyles.join(COLLECTION_FORMATS.csv);
            }

            if (categoryIds) {
                localVarQueryParameter['category_ids[]'] = categoryIds.join(COLLECTION_FORMATS.csv);
            }

            if (prefectureIds) {
                localVarQueryParameter['prefecture_ids[]'] = prefectureIds.join(COLLECTION_FORMATS.csv);
            }

            if (skillIds) {
                localVarQueryParameter['skill_ids[]'] = skillIds.join(COLLECTION_FORMATS.csv);
            }

            if (appealIds) {
                localVarQueryParameter['appeal_ids[]'] = appealIds.join(COLLECTION_FORMATS.csv);
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary get user profile
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getUserProfile: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/users/profile`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary list recommended job offers
         * @param {number} [limit] 返却件数の上限（既定20・上限20）
         * @param {boolean} [excludeApplied] trueの場合、応募済み案件をレスポンスから除外する
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getUserRecommendedJobOffers: async (limit?: number, excludeApplied?: boolean, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/users/recommended_job_offers`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (limit !== undefined) {
                localVarQueryParameter['limit'] = limit;
            }

            if (excludeApplied !== undefined) {
                localVarQueryParameter['exclude_applied'] = excludeApplied;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 関連するお仕事一覧を取得する
         * @summary list related job offers
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getUserRelatedJobOffers: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/users/related_job_offers`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 保存済み検索条件一覧を取得します
         * @summary list searching bookmarks
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getUserSearchingBookmarks: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/users/searching_bookmarks`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary get user skill relations
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getUserSkillRelations: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/users/user_skill_relations`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary 登録後にやることリストの状態を取得する
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getUserTodoList: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/users/todo_list`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary get work preference
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getWorkPreference: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/users/work_preference`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary update client contract extension request
         * @param {string} accessToken 
         * @param {UpdateClientContractExtensionRequest} [updateClientContractExtensionRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateClientContractExtensionRequest: async (accessToken: string, updateClientContractExtensionRequest?: UpdateClientContractExtensionRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'accessToken' is not null or undefined
            assertParamExists('updateClientContractExtensionRequest', 'accessToken', accessToken)
            const localVarPath = `/api/v1/clients/contract_extension_requests/{access_token}`
                .replace(`{${"access_token"}}`, encodeURIComponent(String(accessToken)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(updateClientContractExtensionRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * ClientStaffのパスワードを設定する
         * @summary update client staff password
         * @param {string} staffToken 
         * @param {UpdateClientStaffPasswordRequest} [updateClientStaffPasswordRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateClientStaffPassword: async (staffToken: string, updateClientStaffPasswordRequest?: UpdateClientStaffPasswordRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'staffToken' is not null or undefined
            assertParamExists('updateClientStaffPassword', 'staffToken', staffToken)
            const localVarPath = `/api/v1/clients/staffs/{staff_token}/password`
                .replace(`{${"staff_token"}}`, encodeURIComponent(String(staffToken)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(updateClientStaffPasswordRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary put job offers favorite
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateJobOffersFavorite: async (id: number, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('updateJobOffersFavorite', 'id', id)
            const localVarPath = `/api/v1/users/job_offers/favorites/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication csrfToken required
            await setApiKeyToObject(localVarHeaderParameter, "X-CSRF-TOKEN", configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 紹介者ページで紹介者用URLに付与するトークンを発行する
         * @summary update referral token
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateUserReferralToken: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/users/user/referral_token`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication csrfToken required
            await setApiKeyToObject(localVarHeaderParameter, "X-CSRF-TOKEN", configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary update user skill relations
         * @param {UpdateUserSkillRelationsRequest} updateUserSkillRelationsRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateUserSkillRelations: async (updateUserSkillRelationsRequest: UpdateUserSkillRelationsRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'updateUserSkillRelationsRequest' is not null or undefined
            assertParamExists('updateUserSkillRelations', 'updateUserSkillRelationsRequest', updateUserSkillRelationsRequest)
            const localVarPath = `/api/v1/users/user_skill_relations`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication csrfToken required
            await setApiKeyToObject(localVarHeaderParameter, "X-CSRF-TOKEN", configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(updateUserSkillRelationsRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary update work preference
         * @param {WorkPreferenceForm} workPreferenceForm 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateWorkPreference: async (workPreferenceForm: WorkPreferenceForm, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'workPreferenceForm' is not null or undefined
            assertParamExists('updateWorkPreference', 'workPreferenceForm', workPreferenceForm)
            const localVarPath = `/api/v1/users/work_preference`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication csrfToken required
            await setApiKeyToObject(localVarHeaderParameter, "X-CSRF-TOKEN", configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(workPreferenceForm, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * メンバーのメールアドレスとパスワードでログインする
         * @summary member login
         * @param {number} [jobOfferId] 
         * @param {UserLoginRequest} [userLoginRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        userLogin: async (jobOfferId?: number, userLoginRequest?: UserLoginRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/users/auth`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication csrfToken required
            await setApiKeyToObject(localVarHeaderParameter, "X-CSRF-TOKEN", configuration)

            if (jobOfferId !== undefined) {
                localVarQueryParameter['job_offer_id'] = jobOfferId;
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(userLoginRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * メンバーをログアウトする
         * @summary member logout
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        userLogout: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/users/logout`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication csrfToken required
            await setApiKeyToObject(localVarHeaderParameter, "X-CSRF-TOKEN", configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary create
         * @param {VerifyClientStaffEmailRequest} [verifyClientStaffEmailRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        verifyClientStaffEmail: async (verifyClientStaffEmailRequest?: VerifyClientStaffEmailRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/clients/staff/verify_email`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(verifyClientStaffEmailRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * ClientStaffのアクセストークンを検証する
         * @summary verify client staff access token
         * @param {string} staffToken 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        verifyClientStaffToken: async (staffToken: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'staffToken' is not null or undefined
            assertParamExists('verifyClientStaffToken', 'staffToken', staffToken)
            const localVarPath = `/api/v1/clients/staffs/{staff_token}/verify_token`
                .replace(`{${"staff_token"}}`, encodeURIComponent(String(staffToken)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * V1Api - functional programming interface
 * @export
 */
export const V1ApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = V1ApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @summary list featured job offers for TOP page
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV1UsersTopFeaturedJobOffersGet(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<FeaturedJobOffer>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiV1UsersTopFeaturedJobOffersGet(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['V1Api.apiV1UsersTopFeaturedJobOffersGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary list information for TOP page
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV1UsersTopInformationGet(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<ApiV1UsersTopInformationGet200ResponseInner>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiV1UsersTopInformationGet(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['V1Api.apiV1UsersTopInformationGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary list job offer search categories for TOP page
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV1UsersTopJobOfferSearchCategoriesGet(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<ApiV1UsersTopJobOfferSearchMasterSkillsGet200ResponseInner>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiV1UsersTopJobOfferSearchCategoriesGet(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['V1Api.apiV1UsersTopJobOfferSearchCategoriesGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary list job offer search master skills for TOP page
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiV1UsersTopJobOfferSearchMasterSkillsGet(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<ApiV1UsersTopJobOfferSearchMasterSkillsGet200ResponseInner>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiV1UsersTopJobOfferSearchMasterSkillsGet(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['V1Api.apiV1UsersTopJobOfferSearchMasterSkillsGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * クライアントのメールアドレスとパスワードでログインをする
         * @summary create authenticate token
         * @param {ClientLoginRequest} [clientLoginRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async clientLogin(clientLoginRequest?: ClientLoginRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ClientLogin200Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.clientLogin(clientLoginRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['V1Api.clientLogin']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * クライアントをログアウトさせる
         * @summary delete authenticate token
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async clientLogout(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<VerifyClientStaffEmail200Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.clientLogout(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['V1Api.clientLogout']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary initial invoice information
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async createInitialInvoiceInformation(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<object>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.createInitialInvoiceInformation(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['V1Api.createInitialInvoiceInformation']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary create invoice number
         * @param {CreateInvoiceNumberRequest} [createInvoiceNumberRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async createInvoiceNumber(createInvoiceNumberRequest?: CreateInvoiceNumberRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<CreateInvoiceNumber200Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.createInvoiceNumber(createInvoiceNumberRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['V1Api.createInvoiceNumber']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary create job offer application
         * @param {number} jobOfferId 
         * @param {CreateJobOfferApplicationRequest} createJobOfferApplicationRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async createJobOfferApplication(jobOfferId: number, createJobOfferApplicationRequest: CreateJobOfferApplicationRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<CreateJobOfferApplication200Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.createJobOfferApplication(jobOfferId, createJobOfferApplicationRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['V1Api.createJobOfferApplication']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 紹介用URLのトークンを使用して新しいユーザー登録と紹介を作成する
         * @summary Create a new referral
         * @param {CreateUserReferralRequest} createUserReferralRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async createUserReferral(createUserReferralRequest: CreateUserReferralRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.createUserReferral(createUserReferralRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['V1Api.createUserReferral']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 検索条件を保存する
         * @summary create searching bookmark
         * @param {PostSearchingBookmark} [postSearchingBookmark] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async createUserSearchingBookmark(postSearchingBookmark?: PostSearchingBookmark, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<CreateUserSearchingBookmark200Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.createUserSearchingBookmark(postSearchingBookmark, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['V1Api.createUserSearchingBookmark']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 検索履歴を保存する
         * @summary create searching history
         * @param {CreateUserSearchingHistoryRequest} [createUserSearchingHistoryRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async createUserSearchingHistory(createUserSearchingHistoryRequest?: CreateUserSearchingHistoryRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<CreateUserSearchingHistory200Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.createUserSearchingHistory(createUserSearchingHistoryRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['V1Api.createUserSearchingHistory']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary delete job offers favorite
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async deleteJobOffersFavorite(id: number, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<object>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.deleteJobOffersFavorite(id, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['V1Api.deleteJobOffersFavorite']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 掲載案件候補一覧を取得する
         * @summary list job offers
         * @param {string} [salesforceJobId] 
         * @param {string} [order] 
         * @param {number} [limit] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getAdminJobOffers(salesforceJobId?: string, order?: string, limit?: number, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<AdminJobOffer>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getAdminJobOffers(salesforceJobId, order, limit, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['V1Api.getAdminJobOffers']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary list appeals
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getAppeals(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<GetAppeals200ResponseInner>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getAppeals(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['V1Api.getAppeals']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * クライアント請求詳細を取得する。
         * @summary show
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getClientBill(id: number, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<BillDetail>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getClientBill(id, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['V1Api.getClientBill']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * クライアントのステータス別請求数を取得する
         * @summary get client bill count per bill status
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getClientBillCount(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<BillCount>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getClientBillCount(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['V1Api.getClientBillCount']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * クライアント請求書のPDFを取得する
         * @summary get client ledger sheet
         * @param {number} billId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getClientBillLedgerSheet(billId: number, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<File>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getClientBillLedgerSheet(billId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['V1Api.getClientBillLedgerSheet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * クライアントの請求年一覧を取得する
         * @summary list bill accounting years
         * @param {GetClientBillYearsOrderEnum} [order] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getClientBillYears(order?: GetClientBillYearsOrderEnum, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<BillYear>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getClientBillYears(order, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['V1Api.getClientBillYears']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary index
         * @param {GetClientBillsStatusEnum} [status] 
         * @param {string} [targetYear] 
         * @param {string} [targetMonth] 
         * @param {GetClientBillsOrderEnum} [order] 
         * @param {GetClientBillsDirectionEnum} [direction] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getClientBills(status?: GetClientBillsStatusEnum, targetYear?: string, targetMonth?: string, order?: GetClientBillsOrderEnum, direction?: GetClientBillsDirectionEnum, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<Bill>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getClientBills(status, targetYear, targetMonth, order, direction, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['V1Api.getClientBills']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary get client contract extension request
         * @param {string} accessToken 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getClientContractExtensionRequest(accessToken: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ClientContractExtensionRequest>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getClientContractExtensionRequest(accessToken, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['V1Api.getClientContractExtensionRequest']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * クライアントに紐づく月次作業報告詳細を取得する
         * @summary show
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getClientMonthlyWorkReport(id: number, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<MonthlyWorkReportDetail>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getClientMonthlyWorkReport(id, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['V1Api.getClientMonthlyWorkReport']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary index
         * @param {number} [page] ページ番号
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getClientMonthlyWorkReports(page?: number, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<MonthlyWorkReport>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getClientMonthlyWorkReports(page, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['V1Api.getClientMonthlyWorkReports']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * クライアントのアンケート件数を取得する
         * @summary get count of client questionnaires
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getClientQuestionnaireCount(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<QuestionnaireCount>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getClientQuestionnaireCount(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['V1Api.getClientQuestionnaireCount']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * クライアントのアンケート作成年一覧を取得する
         * @summary list years of client questionnaires
         * @param {GetClientQuestionnaireYearsOrderEnum} [order] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getClientQuestionnaireYears(order?: GetClientQuestionnaireYearsOrderEnum, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<QuestionnaireYear>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getClientQuestionnaireYears(order, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['V1Api.getClientQuestionnaireYears']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 契約更新の確認一覧を取得する
         * @summary index
         * @param {number} [page] 
         * @param {GetClientQuestionnairesStatusEnum} [status] 
         * @param {GetClientQuestionnairesOrderEnum} [order] 
         * @param {GetClientQuestionnairesDirectionEnum} [direction] 
         * @param {string} [targetYear] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getClientQuestionnaires(page?: number, status?: GetClientQuestionnairesStatusEnum, order?: GetClientQuestionnairesOrderEnum, direction?: GetClientQuestionnairesDirectionEnum, targetYear?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<ContractExtensionRequest>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getClientQuestionnaires(page, status, order, direction, targetYear, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['V1Api.getClientQuestionnaires']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary get evaluations
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getEvaluations(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<UserEvaluation>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getEvaluations(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['V1Api.getEvaluations']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary list job offer categories with occupations
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getJobOfferCategoriesOccupations(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<JobOfferCategoryWithOccupations>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getJobOfferCategoriesOccupations(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['V1Api.getJobOfferCategoriesOccupations']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary list categories
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getJobOffersCategories(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<GetJobOffersCategories200ResponseInner>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getJobOffersCategories(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['V1Api.getJobOffersCategories']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary job offers seo
         * @param {Array<number>} [categoryIds] 
         * @param {Array<number>} [skillIds] 
         * @param {number} [page] 
         * @param {Array<number>} [prefectureIds] 
         * @param {string} [searchWord] 
         * @param {Array<number>} [workingDayIds] 
         * @param {Array<number>} [workStyleIds] 
         * @param {Array<number>} [appealIds] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getJobOffersSeo(categoryIds?: Array<number>, skillIds?: Array<number>, page?: number, prefectureIds?: Array<number>, searchWord?: string, workingDayIds?: Array<number>, workStyleIds?: Array<number>, appealIds?: Array<number>, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Seo>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getJobOffersSeo(categoryIds, skillIds, page, prefectureIds, searchWord, workingDayIds, workStyleIds, appealIds, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['V1Api.getJobOffersSeo']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary list prefectures
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getPrefectures(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<Prefecture>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getPrefectures(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['V1Api.getPrefectures']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary list recommended categories
         * @param {Array<string>} [categoryIds] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getRecommendedCategories(categoryIds?: Array<string>, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<JobOfferCategory>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getRecommendedCategories(categoryIds, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['V1Api.getRecommendedCategories']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary list recommended skills
         * @param {Array<string>} [categoryIds] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getRecommendedSkills(categoryIds?: Array<string>, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<MasterSkill>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getRecommendedSkills(categoryIds, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['V1Api.getRecommendedSkills']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 紹介者ページで紹介トークンを取得する
         * @summary get referral token
         * @param {string} token 紹介トークン
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getReferralToken(token: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ReferralTokenResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getReferralToken(token, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['V1Api.getReferralToken']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary list skill_categories
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getSkillCategories(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<SkillCategory>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getSkillCategories(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['V1Api.getSkillCategories']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary 本人確認用の住所情報を取得する
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getUserIdentifyVerificationAddress(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<IdentifyVerificationAddress>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getUserIdentifyVerificationAddress(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['V1Api.getUserIdentifyVerificationAddress']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary job offer detail
         * @param {number} jobOfferId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getUserJobOfferDetail(jobOfferId: number, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<JobOfferDetail>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getUserJobOfferDetail(jobOfferId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['V1Api.getUserJobOfferDetail']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary get job offer summary
         * @param {number} jobOfferId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getUserJobOfferSummary(jobOfferId: number, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<JobOfferSummary>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getUserJobOfferSummary(jobOfferId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['V1Api.getUserJobOfferSummary']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary list job offers
         * @param {string} [word] 検索キーワード
         * @param {number} [minPrice] 単価下限
         * @param {number} [maxPrice] 単価上限
         * @param {boolean} [openonly] 募集中のみ表示するかどうか
         * @param {Array<number>} [workingDays] 稼働日数
         * @param {Array<number>} [workStyles] 稼働形態
         * @param {Array<number>} [categoryIds] 職種カテゴリIDのリスト
         * @param {Array<number>} [prefectureIds] エリア(都道府県)IDのリスト
         * @param {Array<number>} [skillIds] スキルIDのリスト
         * @param {Array<number>} [appealIds] こだわりIDのリスト
         * @param {GetUserJobOffersOrderEnum} [order] ソート順
         * @param {number} [page] ページ番号
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getUserJobOffers(word?: string, minPrice?: number, maxPrice?: number, openonly?: boolean, workingDays?: Array<number>, workStyles?: Array<number>, categoryIds?: Array<number>, prefectureIds?: Array<number>, skillIds?: Array<number>, appealIds?: Array<number>, order?: GetUserJobOffersOrderEnum, page?: number, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<UserJobOffer>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getUserJobOffers(word, minPrice, maxPrice, openonly, workingDays, workStyles, categoryIds, prefectureIds, skillIds, appealIds, order, page, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['V1Api.getUserJobOffers']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary get job offers count
         * @param {string} [word] 検索キーワード
         * @param {number} [minPrice] 単価下限
         * @param {number} [maxPrice] 単価上限
         * @param {boolean} [openonly] 募集中のみ表示するかどうか
         * @param {Array<number>} [workingDays] 稼働日数
         * @param {Array<number>} [workStyles] 稼働形態
         * @param {Array<number>} [categoryIds] 職種カテゴリIDのリスト
         * @param {Array<number>} [prefectureIds] エリア(都道府県)IDのリスト
         * @param {Array<number>} [skillIds] スキルIDのリスト
         * @param {Array<number>} [appealIds] こだわりIDのリスト
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getUserJobOffersCount(word?: string, minPrice?: number, maxPrice?: number, openonly?: boolean, workingDays?: Array<number>, workStyles?: Array<number>, categoryIds?: Array<number>, prefectureIds?: Array<number>, skillIds?: Array<number>, appealIds?: Array<number>, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GetUserJobOffersCount200Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getUserJobOffersCount(word, minPrice, maxPrice, openonly, workingDays, workStyles, categoryIds, prefectureIds, skillIds, appealIds, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['V1Api.getUserJobOffersCount']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary get user profile
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getUserProfile(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Profile>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getUserProfile(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['V1Api.getUserProfile']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary list recommended job offers
         * @param {number} [limit] 返却件数の上限（既定20・上限20）
         * @param {boolean} [excludeApplied] trueの場合、応募済み案件をレスポンスから除外する
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getUserRecommendedJobOffers(limit?: number, excludeApplied?: boolean, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<GetUserRecommendedJobOffers200ResponseInner>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getUserRecommendedJobOffers(limit, excludeApplied, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['V1Api.getUserRecommendedJobOffers']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 関連するお仕事一覧を取得する
         * @summary list related job offers
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getUserRelatedJobOffers(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<JobOffer>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getUserRelatedJobOffers(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['V1Api.getUserRelatedJobOffers']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 保存済み検索条件一覧を取得します
         * @summary list searching bookmarks
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getUserSearchingBookmarks(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<SearchingBookmark>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getUserSearchingBookmarks(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['V1Api.getUserSearchingBookmarks']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary get user skill relations
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getUserSkillRelations(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<UserSkillRelation>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getUserSkillRelations(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['V1Api.getUserSkillRelations']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary 登録後にやることリストの状態を取得する
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getUserTodoList(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<TodoList>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getUserTodoList(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['V1Api.getUserTodoList']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary get work preference
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getWorkPreference(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GetWorkPreference200Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getWorkPreference(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['V1Api.getWorkPreference']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary update client contract extension request
         * @param {string} accessToken 
         * @param {UpdateClientContractExtensionRequest} [updateClientContractExtensionRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updateClientContractExtensionRequest(accessToken: string, updateClientContractExtensionRequest?: UpdateClientContractExtensionRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<object>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updateClientContractExtensionRequest(accessToken, updateClientContractExtensionRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['V1Api.updateClientContractExtensionRequest']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * ClientStaffのパスワードを設定する
         * @summary update client staff password
         * @param {string} staffToken 
         * @param {UpdateClientStaffPasswordRequest} [updateClientStaffPasswordRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updateClientStaffPassword(staffToken: string, updateClientStaffPasswordRequest?: UpdateClientStaffPasswordRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<UpdateClientStaffPassword200Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updateClientStaffPassword(staffToken, updateClientStaffPasswordRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['V1Api.updateClientStaffPassword']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary put job offers favorite
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updateJobOffersFavorite(id: number, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<string>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updateJobOffersFavorite(id, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['V1Api.updateJobOffersFavorite']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 紹介者ページで紹介者用URLに付与するトークンを発行する
         * @summary update referral token
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updateUserReferralToken(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ReferralTokenResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updateUserReferralToken(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['V1Api.updateUserReferralToken']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary update user skill relations
         * @param {UpdateUserSkillRelationsRequest} updateUserSkillRelationsRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updateUserSkillRelations(updateUserSkillRelationsRequest: UpdateUserSkillRelationsRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<UserSkillRelation>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updateUserSkillRelations(updateUserSkillRelationsRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['V1Api.updateUserSkillRelations']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary update work preference
         * @param {WorkPreferenceForm} workPreferenceForm 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updateWorkPreference(workPreferenceForm: WorkPreferenceForm, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<WorkPreference>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updateWorkPreference(workPreferenceForm, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['V1Api.updateWorkPreference']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * メンバーのメールアドレスとパスワードでログインする
         * @summary member login
         * @param {number} [jobOfferId] 
         * @param {UserLoginRequest} [userLoginRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async userLogin(jobOfferId?: number, userLoginRequest?: UserLoginRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<UserLogin200Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.userLogin(jobOfferId, userLoginRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['V1Api.userLogin']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * メンバーをログアウトする
         * @summary member logout
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async userLogout(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.userLogout(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['V1Api.userLogout']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary create
         * @param {VerifyClientStaffEmailRequest} [verifyClientStaffEmailRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async verifyClientStaffEmail(verifyClientStaffEmailRequest?: VerifyClientStaffEmailRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<VerifyClientStaffEmail200Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.verifyClientStaffEmail(verifyClientStaffEmailRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['V1Api.verifyClientStaffEmail']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * ClientStaffのアクセストークンを検証する
         * @summary verify client staff access token
         * @param {string} staffToken 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async verifyClientStaffToken(staffToken: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<object>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.verifyClientStaffToken(staffToken, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['V1Api.verifyClientStaffToken']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * V1Api - factory interface
 * @export
 */
export const V1ApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = V1ApiFp(configuration)
    return {
        /**
         * 
         * @summary list featured job offers for TOP page
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1UsersTopFeaturedJobOffersGet(options?: RawAxiosRequestConfig): AxiosPromise<Array<FeaturedJobOffer>> {
            return localVarFp.apiV1UsersTopFeaturedJobOffersGet(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary list information for TOP page
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1UsersTopInformationGet(options?: RawAxiosRequestConfig): AxiosPromise<Array<ApiV1UsersTopInformationGet200ResponseInner>> {
            return localVarFp.apiV1UsersTopInformationGet(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary list job offer search categories for TOP page
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1UsersTopJobOfferSearchCategoriesGet(options?: RawAxiosRequestConfig): AxiosPromise<Array<ApiV1UsersTopJobOfferSearchMasterSkillsGet200ResponseInner>> {
            return localVarFp.apiV1UsersTopJobOfferSearchCategoriesGet(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary list job offer search master skills for TOP page
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiV1UsersTopJobOfferSearchMasterSkillsGet(options?: RawAxiosRequestConfig): AxiosPromise<Array<ApiV1UsersTopJobOfferSearchMasterSkillsGet200ResponseInner>> {
            return localVarFp.apiV1UsersTopJobOfferSearchMasterSkillsGet(options).then((request) => request(axios, basePath));
        },
        /**
         * クライアントのメールアドレスとパスワードでログインをする
         * @summary create authenticate token
         * @param {ClientLoginRequest} [clientLoginRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        clientLogin(clientLoginRequest?: ClientLoginRequest, options?: RawAxiosRequestConfig): AxiosPromise<ClientLogin200Response> {
            return localVarFp.clientLogin(clientLoginRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * クライアントをログアウトさせる
         * @summary delete authenticate token
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        clientLogout(options?: RawAxiosRequestConfig): AxiosPromise<VerifyClientStaffEmail200Response> {
            return localVarFp.clientLogout(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary initial invoice information
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createInitialInvoiceInformation(options?: RawAxiosRequestConfig): AxiosPromise<object> {
            return localVarFp.createInitialInvoiceInformation(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary create invoice number
         * @param {CreateInvoiceNumberRequest} [createInvoiceNumberRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createInvoiceNumber(createInvoiceNumberRequest?: CreateInvoiceNumberRequest, options?: RawAxiosRequestConfig): AxiosPromise<CreateInvoiceNumber200Response> {
            return localVarFp.createInvoiceNumber(createInvoiceNumberRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary create job offer application
         * @param {number} jobOfferId 
         * @param {CreateJobOfferApplicationRequest} createJobOfferApplicationRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createJobOfferApplication(jobOfferId: number, createJobOfferApplicationRequest: CreateJobOfferApplicationRequest, options?: RawAxiosRequestConfig): AxiosPromise<CreateJobOfferApplication200Response> {
            return localVarFp.createJobOfferApplication(jobOfferId, createJobOfferApplicationRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 紹介用URLのトークンを使用して新しいユーザー登録と紹介を作成する
         * @summary Create a new referral
         * @param {CreateUserReferralRequest} createUserReferralRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createUserReferral(createUserReferralRequest: CreateUserReferralRequest, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.createUserReferral(createUserReferralRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 検索条件を保存する
         * @summary create searching bookmark
         * @param {PostSearchingBookmark} [postSearchingBookmark] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createUserSearchingBookmark(postSearchingBookmark?: PostSearchingBookmark, options?: RawAxiosRequestConfig): AxiosPromise<CreateUserSearchingBookmark200Response> {
            return localVarFp.createUserSearchingBookmark(postSearchingBookmark, options).then((request) => request(axios, basePath));
        },
        /**
         * 検索履歴を保存する
         * @summary create searching history
         * @param {CreateUserSearchingHistoryRequest} [createUserSearchingHistoryRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createUserSearchingHistory(createUserSearchingHistoryRequest?: CreateUserSearchingHistoryRequest, options?: RawAxiosRequestConfig): AxiosPromise<CreateUserSearchingHistory200Response> {
            return localVarFp.createUserSearchingHistory(createUserSearchingHistoryRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary delete job offers favorite
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteJobOffersFavorite(id: number, options?: RawAxiosRequestConfig): AxiosPromise<object> {
            return localVarFp.deleteJobOffersFavorite(id, options).then((request) => request(axios, basePath));
        },
        /**
         * 掲載案件候補一覧を取得する
         * @summary list job offers
         * @param {string} [salesforceJobId] 
         * @param {string} [order] 
         * @param {number} [limit] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAdminJobOffers(salesforceJobId?: string, order?: string, limit?: number, options?: RawAxiosRequestConfig): AxiosPromise<Array<AdminJobOffer>> {
            return localVarFp.getAdminJobOffers(salesforceJobId, order, limit, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary list appeals
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAppeals(options?: RawAxiosRequestConfig): AxiosPromise<Array<GetAppeals200ResponseInner>> {
            return localVarFp.getAppeals(options).then((request) => request(axios, basePath));
        },
        /**
         * クライアント請求詳細を取得する。
         * @summary show
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getClientBill(id: number, options?: RawAxiosRequestConfig): AxiosPromise<BillDetail> {
            return localVarFp.getClientBill(id, options).then((request) => request(axios, basePath));
        },
        /**
         * クライアントのステータス別請求数を取得する
         * @summary get client bill count per bill status
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getClientBillCount(options?: RawAxiosRequestConfig): AxiosPromise<BillCount> {
            return localVarFp.getClientBillCount(options).then((request) => request(axios, basePath));
        },
        /**
         * クライアント請求書のPDFを取得する
         * @summary get client ledger sheet
         * @param {number} billId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getClientBillLedgerSheet(billId: number, options?: RawAxiosRequestConfig): AxiosPromise<File> {
            return localVarFp.getClientBillLedgerSheet(billId, options).then((request) => request(axios, basePath));
        },
        /**
         * クライアントの請求年一覧を取得する
         * @summary list bill accounting years
         * @param {GetClientBillYearsOrderEnum} [order] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getClientBillYears(order?: GetClientBillYearsOrderEnum, options?: RawAxiosRequestConfig): AxiosPromise<Array<BillYear>> {
            return localVarFp.getClientBillYears(order, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary index
         * @param {GetClientBillsStatusEnum} [status] 
         * @param {string} [targetYear] 
         * @param {string} [targetMonth] 
         * @param {GetClientBillsOrderEnum} [order] 
         * @param {GetClientBillsDirectionEnum} [direction] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getClientBills(status?: GetClientBillsStatusEnum, targetYear?: string, targetMonth?: string, order?: GetClientBillsOrderEnum, direction?: GetClientBillsDirectionEnum, options?: RawAxiosRequestConfig): AxiosPromise<Array<Bill>> {
            return localVarFp.getClientBills(status, targetYear, targetMonth, order, direction, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary get client contract extension request
         * @param {string} accessToken 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getClientContractExtensionRequest(accessToken: string, options?: RawAxiosRequestConfig): AxiosPromise<ClientContractExtensionRequest> {
            return localVarFp.getClientContractExtensionRequest(accessToken, options).then((request) => request(axios, basePath));
        },
        /**
         * クライアントに紐づく月次作業報告詳細を取得する
         * @summary show
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getClientMonthlyWorkReport(id: number, options?: RawAxiosRequestConfig): AxiosPromise<MonthlyWorkReportDetail> {
            return localVarFp.getClientMonthlyWorkReport(id, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary index
         * @param {number} [page] ページ番号
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getClientMonthlyWorkReports(page?: number, options?: RawAxiosRequestConfig): AxiosPromise<Array<MonthlyWorkReport>> {
            return localVarFp.getClientMonthlyWorkReports(page, options).then((request) => request(axios, basePath));
        },
        /**
         * クライアントのアンケート件数を取得する
         * @summary get count of client questionnaires
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getClientQuestionnaireCount(options?: RawAxiosRequestConfig): AxiosPromise<QuestionnaireCount> {
            return localVarFp.getClientQuestionnaireCount(options).then((request) => request(axios, basePath));
        },
        /**
         * クライアントのアンケート作成年一覧を取得する
         * @summary list years of client questionnaires
         * @param {GetClientQuestionnaireYearsOrderEnum} [order] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getClientQuestionnaireYears(order?: GetClientQuestionnaireYearsOrderEnum, options?: RawAxiosRequestConfig): AxiosPromise<Array<QuestionnaireYear>> {
            return localVarFp.getClientQuestionnaireYears(order, options).then((request) => request(axios, basePath));
        },
        /**
         * 契約更新の確認一覧を取得する
         * @summary index
         * @param {number} [page] 
         * @param {GetClientQuestionnairesStatusEnum} [status] 
         * @param {GetClientQuestionnairesOrderEnum} [order] 
         * @param {GetClientQuestionnairesDirectionEnum} [direction] 
         * @param {string} [targetYear] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getClientQuestionnaires(page?: number, status?: GetClientQuestionnairesStatusEnum, order?: GetClientQuestionnairesOrderEnum, direction?: GetClientQuestionnairesDirectionEnum, targetYear?: string, options?: RawAxiosRequestConfig): AxiosPromise<Array<ContractExtensionRequest>> {
            return localVarFp.getClientQuestionnaires(page, status, order, direction, targetYear, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary get evaluations
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getEvaluations(options?: RawAxiosRequestConfig): AxiosPromise<Array<UserEvaluation>> {
            return localVarFp.getEvaluations(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary list job offer categories with occupations
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getJobOfferCategoriesOccupations(options?: RawAxiosRequestConfig): AxiosPromise<Array<JobOfferCategoryWithOccupations>> {
            return localVarFp.getJobOfferCategoriesOccupations(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary list categories
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getJobOffersCategories(options?: RawAxiosRequestConfig): AxiosPromise<Array<GetJobOffersCategories200ResponseInner>> {
            return localVarFp.getJobOffersCategories(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary job offers seo
         * @param {Array<number>} [categoryIds] 
         * @param {Array<number>} [skillIds] 
         * @param {number} [page] 
         * @param {Array<number>} [prefectureIds] 
         * @param {string} [searchWord] 
         * @param {Array<number>} [workingDayIds] 
         * @param {Array<number>} [workStyleIds] 
         * @param {Array<number>} [appealIds] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getJobOffersSeo(categoryIds?: Array<number>, skillIds?: Array<number>, page?: number, prefectureIds?: Array<number>, searchWord?: string, workingDayIds?: Array<number>, workStyleIds?: Array<number>, appealIds?: Array<number>, options?: RawAxiosRequestConfig): AxiosPromise<Seo> {
            return localVarFp.getJobOffersSeo(categoryIds, skillIds, page, prefectureIds, searchWord, workingDayIds, workStyleIds, appealIds, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary list prefectures
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getPrefectures(options?: RawAxiosRequestConfig): AxiosPromise<Array<Prefecture>> {
            return localVarFp.getPrefectures(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary list recommended categories
         * @param {Array<string>} [categoryIds] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getRecommendedCategories(categoryIds?: Array<string>, options?: RawAxiosRequestConfig): AxiosPromise<Array<JobOfferCategory>> {
            return localVarFp.getRecommendedCategories(categoryIds, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary list recommended skills
         * @param {Array<string>} [categoryIds] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getRecommendedSkills(categoryIds?: Array<string>, options?: RawAxiosRequestConfig): AxiosPromise<Array<MasterSkill>> {
            return localVarFp.getRecommendedSkills(categoryIds, options).then((request) => request(axios, basePath));
        },
        /**
         * 紹介者ページで紹介トークンを取得する
         * @summary get referral token
         * @param {string} token 紹介トークン
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getReferralToken(token: string, options?: RawAxiosRequestConfig): AxiosPromise<ReferralTokenResponse> {
            return localVarFp.getReferralToken(token, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary list skill_categories
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getSkillCategories(options?: RawAxiosRequestConfig): AxiosPromise<Array<SkillCategory>> {
            return localVarFp.getSkillCategories(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary 本人確認用の住所情報を取得する
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getUserIdentifyVerificationAddress(options?: RawAxiosRequestConfig): AxiosPromise<IdentifyVerificationAddress> {
            return localVarFp.getUserIdentifyVerificationAddress(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary job offer detail
         * @param {number} jobOfferId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getUserJobOfferDetail(jobOfferId: number, options?: RawAxiosRequestConfig): AxiosPromise<JobOfferDetail> {
            return localVarFp.getUserJobOfferDetail(jobOfferId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary get job offer summary
         * @param {number} jobOfferId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getUserJobOfferSummary(jobOfferId: number, options?: RawAxiosRequestConfig): AxiosPromise<JobOfferSummary> {
            return localVarFp.getUserJobOfferSummary(jobOfferId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary list job offers
         * @param {string} [word] 検索キーワード
         * @param {number} [minPrice] 単価下限
         * @param {number} [maxPrice] 単価上限
         * @param {boolean} [openonly] 募集中のみ表示するかどうか
         * @param {Array<number>} [workingDays] 稼働日数
         * @param {Array<number>} [workStyles] 稼働形態
         * @param {Array<number>} [categoryIds] 職種カテゴリIDのリスト
         * @param {Array<number>} [prefectureIds] エリア(都道府県)IDのリスト
         * @param {Array<number>} [skillIds] スキルIDのリスト
         * @param {Array<number>} [appealIds] こだわりIDのリスト
         * @param {GetUserJobOffersOrderEnum} [order] ソート順
         * @param {number} [page] ページ番号
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getUserJobOffers(word?: string, minPrice?: number, maxPrice?: number, openonly?: boolean, workingDays?: Array<number>, workStyles?: Array<number>, categoryIds?: Array<number>, prefectureIds?: Array<number>, skillIds?: Array<number>, appealIds?: Array<number>, order?: GetUserJobOffersOrderEnum, page?: number, options?: RawAxiosRequestConfig): AxiosPromise<Array<UserJobOffer>> {
            return localVarFp.getUserJobOffers(word, minPrice, maxPrice, openonly, workingDays, workStyles, categoryIds, prefectureIds, skillIds, appealIds, order, page, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary get job offers count
         * @param {string} [word] 検索キーワード
         * @param {number} [minPrice] 単価下限
         * @param {number} [maxPrice] 単価上限
         * @param {boolean} [openonly] 募集中のみ表示するかどうか
         * @param {Array<number>} [workingDays] 稼働日数
         * @param {Array<number>} [workStyles] 稼働形態
         * @param {Array<number>} [categoryIds] 職種カテゴリIDのリスト
         * @param {Array<number>} [prefectureIds] エリア(都道府県)IDのリスト
         * @param {Array<number>} [skillIds] スキルIDのリスト
         * @param {Array<number>} [appealIds] こだわりIDのリスト
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getUserJobOffersCount(word?: string, minPrice?: number, maxPrice?: number, openonly?: boolean, workingDays?: Array<number>, workStyles?: Array<number>, categoryIds?: Array<number>, prefectureIds?: Array<number>, skillIds?: Array<number>, appealIds?: Array<number>, options?: RawAxiosRequestConfig): AxiosPromise<GetUserJobOffersCount200Response> {
            return localVarFp.getUserJobOffersCount(word, minPrice, maxPrice, openonly, workingDays, workStyles, categoryIds, prefectureIds, skillIds, appealIds, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary get user profile
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getUserProfile(options?: RawAxiosRequestConfig): AxiosPromise<Profile> {
            return localVarFp.getUserProfile(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary list recommended job offers
         * @param {number} [limit] 返却件数の上限（既定20・上限20）
         * @param {boolean} [excludeApplied] trueの場合、応募済み案件をレスポンスから除外する
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getUserRecommendedJobOffers(limit?: number, excludeApplied?: boolean, options?: RawAxiosRequestConfig): AxiosPromise<Array<GetUserRecommendedJobOffers200ResponseInner>> {
            return localVarFp.getUserRecommendedJobOffers(limit, excludeApplied, options).then((request) => request(axios, basePath));
        },
        /**
         * 関連するお仕事一覧を取得する
         * @summary list related job offers
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getUserRelatedJobOffers(options?: RawAxiosRequestConfig): AxiosPromise<Array<JobOffer>> {
            return localVarFp.getUserRelatedJobOffers(options).then((request) => request(axios, basePath));
        },
        /**
         * 保存済み検索条件一覧を取得します
         * @summary list searching bookmarks
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getUserSearchingBookmarks(options?: RawAxiosRequestConfig): AxiosPromise<Array<SearchingBookmark>> {
            return localVarFp.getUserSearchingBookmarks(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary get user skill relations
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getUserSkillRelations(options?: RawAxiosRequestConfig): AxiosPromise<Array<UserSkillRelation>> {
            return localVarFp.getUserSkillRelations(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary 登録後にやることリストの状態を取得する
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getUserTodoList(options?: RawAxiosRequestConfig): AxiosPromise<TodoList> {
            return localVarFp.getUserTodoList(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary get work preference
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getWorkPreference(options?: RawAxiosRequestConfig): AxiosPromise<GetWorkPreference200Response> {
            return localVarFp.getWorkPreference(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary update client contract extension request
         * @param {string} accessToken 
         * @param {UpdateClientContractExtensionRequest} [updateClientContractExtensionRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateClientContractExtensionRequest(accessToken: string, updateClientContractExtensionRequest?: UpdateClientContractExtensionRequest, options?: RawAxiosRequestConfig): AxiosPromise<object> {
            return localVarFp.updateClientContractExtensionRequest(accessToken, updateClientContractExtensionRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * ClientStaffのパスワードを設定する
         * @summary update client staff password
         * @param {string} staffToken 
         * @param {UpdateClientStaffPasswordRequest} [updateClientStaffPasswordRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateClientStaffPassword(staffToken: string, updateClientStaffPasswordRequest?: UpdateClientStaffPasswordRequest, options?: RawAxiosRequestConfig): AxiosPromise<UpdateClientStaffPassword200Response> {
            return localVarFp.updateClientStaffPassword(staffToken, updateClientStaffPasswordRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary put job offers favorite
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateJobOffersFavorite(id: number, options?: RawAxiosRequestConfig): AxiosPromise<string> {
            return localVarFp.updateJobOffersFavorite(id, options).then((request) => request(axios, basePath));
        },
        /**
         * 紹介者ページで紹介者用URLに付与するトークンを発行する
         * @summary update referral token
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateUserReferralToken(options?: RawAxiosRequestConfig): AxiosPromise<ReferralTokenResponse> {
            return localVarFp.updateUserReferralToken(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary update user skill relations
         * @param {UpdateUserSkillRelationsRequest} updateUserSkillRelationsRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateUserSkillRelations(updateUserSkillRelationsRequest: UpdateUserSkillRelationsRequest, options?: RawAxiosRequestConfig): AxiosPromise<Array<UserSkillRelation>> {
            return localVarFp.updateUserSkillRelations(updateUserSkillRelationsRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary update work preference
         * @param {WorkPreferenceForm} workPreferenceForm 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateWorkPreference(workPreferenceForm: WorkPreferenceForm, options?: RawAxiosRequestConfig): AxiosPromise<WorkPreference> {
            return localVarFp.updateWorkPreference(workPreferenceForm, options).then((request) => request(axios, basePath));
        },
        /**
         * メンバーのメールアドレスとパスワードでログインする
         * @summary member login
         * @param {number} [jobOfferId] 
         * @param {UserLoginRequest} [userLoginRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        userLogin(jobOfferId?: number, userLoginRequest?: UserLoginRequest, options?: RawAxiosRequestConfig): AxiosPromise<UserLogin200Response> {
            return localVarFp.userLogin(jobOfferId, userLoginRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * メンバーをログアウトする
         * @summary member logout
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        userLogout(options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.userLogout(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary create
         * @param {VerifyClientStaffEmailRequest} [verifyClientStaffEmailRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        verifyClientStaffEmail(verifyClientStaffEmailRequest?: VerifyClientStaffEmailRequest, options?: RawAxiosRequestConfig): AxiosPromise<VerifyClientStaffEmail200Response> {
            return localVarFp.verifyClientStaffEmail(verifyClientStaffEmailRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * ClientStaffのアクセストークンを検証する
         * @summary verify client staff access token
         * @param {string} staffToken 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        verifyClientStaffToken(staffToken: string, options?: RawAxiosRequestConfig): AxiosPromise<object> {
            return localVarFp.verifyClientStaffToken(staffToken, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * V1Api - object-oriented interface
 * @export
 * @class V1Api
 * @extends {BaseAPI}
 */
export class V1Api extends BaseAPI {
    /**
     * 
     * @summary list featured job offers for TOP page
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof V1Api
     */
    public apiV1UsersTopFeaturedJobOffersGet(options?: RawAxiosRequestConfig) {
        return V1ApiFp(this.configuration).apiV1UsersTopFeaturedJobOffersGet(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary list information for TOP page
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof V1Api
     */
    public apiV1UsersTopInformationGet(options?: RawAxiosRequestConfig) {
        return V1ApiFp(this.configuration).apiV1UsersTopInformationGet(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary list job offer search categories for TOP page
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof V1Api
     */
    public apiV1UsersTopJobOfferSearchCategoriesGet(options?: RawAxiosRequestConfig) {
        return V1ApiFp(this.configuration).apiV1UsersTopJobOfferSearchCategoriesGet(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary list job offer search master skills for TOP page
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof V1Api
     */
    public apiV1UsersTopJobOfferSearchMasterSkillsGet(options?: RawAxiosRequestConfig) {
        return V1ApiFp(this.configuration).apiV1UsersTopJobOfferSearchMasterSkillsGet(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * クライアントのメールアドレスとパスワードでログインをする
     * @summary create authenticate token
     * @param {ClientLoginRequest} [clientLoginRequest] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof V1Api
     */
    public clientLogin(clientLoginRequest?: ClientLoginRequest, options?: RawAxiosRequestConfig) {
        return V1ApiFp(this.configuration).clientLogin(clientLoginRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * クライアントをログアウトさせる
     * @summary delete authenticate token
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof V1Api
     */
    public clientLogout(options?: RawAxiosRequestConfig) {
        return V1ApiFp(this.configuration).clientLogout(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary initial invoice information
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof V1Api
     */
    public createInitialInvoiceInformation(options?: RawAxiosRequestConfig) {
        return V1ApiFp(this.configuration).createInitialInvoiceInformation(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary create invoice number
     * @param {CreateInvoiceNumberRequest} [createInvoiceNumberRequest] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof V1Api
     */
    public createInvoiceNumber(createInvoiceNumberRequest?: CreateInvoiceNumberRequest, options?: RawAxiosRequestConfig) {
        return V1ApiFp(this.configuration).createInvoiceNumber(createInvoiceNumberRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary create job offer application
     * @param {number} jobOfferId 
     * @param {CreateJobOfferApplicationRequest} createJobOfferApplicationRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof V1Api
     */
    public createJobOfferApplication(jobOfferId: number, createJobOfferApplicationRequest: CreateJobOfferApplicationRequest, options?: RawAxiosRequestConfig) {
        return V1ApiFp(this.configuration).createJobOfferApplication(jobOfferId, createJobOfferApplicationRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 紹介用URLのトークンを使用して新しいユーザー登録と紹介を作成する
     * @summary Create a new referral
     * @param {CreateUserReferralRequest} createUserReferralRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof V1Api
     */
    public createUserReferral(createUserReferralRequest: CreateUserReferralRequest, options?: RawAxiosRequestConfig) {
        return V1ApiFp(this.configuration).createUserReferral(createUserReferralRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 検索条件を保存する
     * @summary create searching bookmark
     * @param {PostSearchingBookmark} [postSearchingBookmark] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof V1Api
     */
    public createUserSearchingBookmark(postSearchingBookmark?: PostSearchingBookmark, options?: RawAxiosRequestConfig) {
        return V1ApiFp(this.configuration).createUserSearchingBookmark(postSearchingBookmark, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 検索履歴を保存する
     * @summary create searching history
     * @param {CreateUserSearchingHistoryRequest} [createUserSearchingHistoryRequest] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof V1Api
     */
    public createUserSearchingHistory(createUserSearchingHistoryRequest?: CreateUserSearchingHistoryRequest, options?: RawAxiosRequestConfig) {
        return V1ApiFp(this.configuration).createUserSearchingHistory(createUserSearchingHistoryRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary delete job offers favorite
     * @param {number} id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof V1Api
     */
    public deleteJobOffersFavorite(id: number, options?: RawAxiosRequestConfig) {
        return V1ApiFp(this.configuration).deleteJobOffersFavorite(id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 掲載案件候補一覧を取得する
     * @summary list job offers
     * @param {string} [salesforceJobId] 
     * @param {string} [order] 
     * @param {number} [limit] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof V1Api
     */
    public getAdminJobOffers(salesforceJobId?: string, order?: string, limit?: number, options?: RawAxiosRequestConfig) {
        return V1ApiFp(this.configuration).getAdminJobOffers(salesforceJobId, order, limit, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary list appeals
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof V1Api
     */
    public getAppeals(options?: RawAxiosRequestConfig) {
        return V1ApiFp(this.configuration).getAppeals(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * クライアント請求詳細を取得する。
     * @summary show
     * @param {number} id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof V1Api
     */
    public getClientBill(id: number, options?: RawAxiosRequestConfig) {
        return V1ApiFp(this.configuration).getClientBill(id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * クライアントのステータス別請求数を取得する
     * @summary get client bill count per bill status
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof V1Api
     */
    public getClientBillCount(options?: RawAxiosRequestConfig) {
        return V1ApiFp(this.configuration).getClientBillCount(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * クライアント請求書のPDFを取得する
     * @summary get client ledger sheet
     * @param {number} billId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof V1Api
     */
    public getClientBillLedgerSheet(billId: number, options?: RawAxiosRequestConfig) {
        return V1ApiFp(this.configuration).getClientBillLedgerSheet(billId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * クライアントの請求年一覧を取得する
     * @summary list bill accounting years
     * @param {GetClientBillYearsOrderEnum} [order] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof V1Api
     */
    public getClientBillYears(order?: GetClientBillYearsOrderEnum, options?: RawAxiosRequestConfig) {
        return V1ApiFp(this.configuration).getClientBillYears(order, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary index
     * @param {GetClientBillsStatusEnum} [status] 
     * @param {string} [targetYear] 
     * @param {string} [targetMonth] 
     * @param {GetClientBillsOrderEnum} [order] 
     * @param {GetClientBillsDirectionEnum} [direction] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof V1Api
     */
    public getClientBills(status?: GetClientBillsStatusEnum, targetYear?: string, targetMonth?: string, order?: GetClientBillsOrderEnum, direction?: GetClientBillsDirectionEnum, options?: RawAxiosRequestConfig) {
        return V1ApiFp(this.configuration).getClientBills(status, targetYear, targetMonth, order, direction, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary get client contract extension request
     * @param {string} accessToken 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof V1Api
     */
    public getClientContractExtensionRequest(accessToken: string, options?: RawAxiosRequestConfig) {
        return V1ApiFp(this.configuration).getClientContractExtensionRequest(accessToken, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * クライアントに紐づく月次作業報告詳細を取得する
     * @summary show
     * @param {number} id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof V1Api
     */
    public getClientMonthlyWorkReport(id: number, options?: RawAxiosRequestConfig) {
        return V1ApiFp(this.configuration).getClientMonthlyWorkReport(id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary index
     * @param {number} [page] ページ番号
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof V1Api
     */
    public getClientMonthlyWorkReports(page?: number, options?: RawAxiosRequestConfig) {
        return V1ApiFp(this.configuration).getClientMonthlyWorkReports(page, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * クライアントのアンケート件数を取得する
     * @summary get count of client questionnaires
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof V1Api
     */
    public getClientQuestionnaireCount(options?: RawAxiosRequestConfig) {
        return V1ApiFp(this.configuration).getClientQuestionnaireCount(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * クライアントのアンケート作成年一覧を取得する
     * @summary list years of client questionnaires
     * @param {GetClientQuestionnaireYearsOrderEnum} [order] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof V1Api
     */
    public getClientQuestionnaireYears(order?: GetClientQuestionnaireYearsOrderEnum, options?: RawAxiosRequestConfig) {
        return V1ApiFp(this.configuration).getClientQuestionnaireYears(order, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 契約更新の確認一覧を取得する
     * @summary index
     * @param {number} [page] 
     * @param {GetClientQuestionnairesStatusEnum} [status] 
     * @param {GetClientQuestionnairesOrderEnum} [order] 
     * @param {GetClientQuestionnairesDirectionEnum} [direction] 
     * @param {string} [targetYear] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof V1Api
     */
    public getClientQuestionnaires(page?: number, status?: GetClientQuestionnairesStatusEnum, order?: GetClientQuestionnairesOrderEnum, direction?: GetClientQuestionnairesDirectionEnum, targetYear?: string, options?: RawAxiosRequestConfig) {
        return V1ApiFp(this.configuration).getClientQuestionnaires(page, status, order, direction, targetYear, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary get evaluations
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof V1Api
     */
    public getEvaluations(options?: RawAxiosRequestConfig) {
        return V1ApiFp(this.configuration).getEvaluations(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary list job offer categories with occupations
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof V1Api
     */
    public getJobOfferCategoriesOccupations(options?: RawAxiosRequestConfig) {
        return V1ApiFp(this.configuration).getJobOfferCategoriesOccupations(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary list categories
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof V1Api
     */
    public getJobOffersCategories(options?: RawAxiosRequestConfig) {
        return V1ApiFp(this.configuration).getJobOffersCategories(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary job offers seo
     * @param {Array<number>} [categoryIds] 
     * @param {Array<number>} [skillIds] 
     * @param {number} [page] 
     * @param {Array<number>} [prefectureIds] 
     * @param {string} [searchWord] 
     * @param {Array<number>} [workingDayIds] 
     * @param {Array<number>} [workStyleIds] 
     * @param {Array<number>} [appealIds] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof V1Api
     */
    public getJobOffersSeo(categoryIds?: Array<number>, skillIds?: Array<number>, page?: number, prefectureIds?: Array<number>, searchWord?: string, workingDayIds?: Array<number>, workStyleIds?: Array<number>, appealIds?: Array<number>, options?: RawAxiosRequestConfig) {
        return V1ApiFp(this.configuration).getJobOffersSeo(categoryIds, skillIds, page, prefectureIds, searchWord, workingDayIds, workStyleIds, appealIds, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary list prefectures
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof V1Api
     */
    public getPrefectures(options?: RawAxiosRequestConfig) {
        return V1ApiFp(this.configuration).getPrefectures(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary list recommended categories
     * @param {Array<string>} [categoryIds] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof V1Api
     */
    public getRecommendedCategories(categoryIds?: Array<string>, options?: RawAxiosRequestConfig) {
        return V1ApiFp(this.configuration).getRecommendedCategories(categoryIds, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary list recommended skills
     * @param {Array<string>} [categoryIds] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof V1Api
     */
    public getRecommendedSkills(categoryIds?: Array<string>, options?: RawAxiosRequestConfig) {
        return V1ApiFp(this.configuration).getRecommendedSkills(categoryIds, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 紹介者ページで紹介トークンを取得する
     * @summary get referral token
     * @param {string} token 紹介トークン
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof V1Api
     */
    public getReferralToken(token: string, options?: RawAxiosRequestConfig) {
        return V1ApiFp(this.configuration).getReferralToken(token, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary list skill_categories
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof V1Api
     */
    public getSkillCategories(options?: RawAxiosRequestConfig) {
        return V1ApiFp(this.configuration).getSkillCategories(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary 本人確認用の住所情報を取得する
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof V1Api
     */
    public getUserIdentifyVerificationAddress(options?: RawAxiosRequestConfig) {
        return V1ApiFp(this.configuration).getUserIdentifyVerificationAddress(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary job offer detail
     * @param {number} jobOfferId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof V1Api
     */
    public getUserJobOfferDetail(jobOfferId: number, options?: RawAxiosRequestConfig) {
        return V1ApiFp(this.configuration).getUserJobOfferDetail(jobOfferId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary get job offer summary
     * @param {number} jobOfferId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof V1Api
     */
    public getUserJobOfferSummary(jobOfferId: number, options?: RawAxiosRequestConfig) {
        return V1ApiFp(this.configuration).getUserJobOfferSummary(jobOfferId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary list job offers
     * @param {string} [word] 検索キーワード
     * @param {number} [minPrice] 単価下限
     * @param {number} [maxPrice] 単価上限
     * @param {boolean} [openonly] 募集中のみ表示するかどうか
     * @param {Array<number>} [workingDays] 稼働日数
     * @param {Array<number>} [workStyles] 稼働形態
     * @param {Array<number>} [categoryIds] 職種カテゴリIDのリスト
     * @param {Array<number>} [prefectureIds] エリア(都道府県)IDのリスト
     * @param {Array<number>} [skillIds] スキルIDのリスト
     * @param {Array<number>} [appealIds] こだわりIDのリスト
     * @param {GetUserJobOffersOrderEnum} [order] ソート順
     * @param {number} [page] ページ番号
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof V1Api
     */
    public getUserJobOffers(word?: string, minPrice?: number, maxPrice?: number, openonly?: boolean, workingDays?: Array<number>, workStyles?: Array<number>, categoryIds?: Array<number>, prefectureIds?: Array<number>, skillIds?: Array<number>, appealIds?: Array<number>, order?: GetUserJobOffersOrderEnum, page?: number, options?: RawAxiosRequestConfig) {
        return V1ApiFp(this.configuration).getUserJobOffers(word, minPrice, maxPrice, openonly, workingDays, workStyles, categoryIds, prefectureIds, skillIds, appealIds, order, page, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary get job offers count
     * @param {string} [word] 検索キーワード
     * @param {number} [minPrice] 単価下限
     * @param {number} [maxPrice] 単価上限
     * @param {boolean} [openonly] 募集中のみ表示するかどうか
     * @param {Array<number>} [workingDays] 稼働日数
     * @param {Array<number>} [workStyles] 稼働形態
     * @param {Array<number>} [categoryIds] 職種カテゴリIDのリスト
     * @param {Array<number>} [prefectureIds] エリア(都道府県)IDのリスト
     * @param {Array<number>} [skillIds] スキルIDのリスト
     * @param {Array<number>} [appealIds] こだわりIDのリスト
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof V1Api
     */
    public getUserJobOffersCount(word?: string, minPrice?: number, maxPrice?: number, openonly?: boolean, workingDays?: Array<number>, workStyles?: Array<number>, categoryIds?: Array<number>, prefectureIds?: Array<number>, skillIds?: Array<number>, appealIds?: Array<number>, options?: RawAxiosRequestConfig) {
        return V1ApiFp(this.configuration).getUserJobOffersCount(word, minPrice, maxPrice, openonly, workingDays, workStyles, categoryIds, prefectureIds, skillIds, appealIds, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary get user profile
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof V1Api
     */
    public getUserProfile(options?: RawAxiosRequestConfig) {
        return V1ApiFp(this.configuration).getUserProfile(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary list recommended job offers
     * @param {number} [limit] 返却件数の上限（既定20・上限20）
     * @param {boolean} [excludeApplied] trueの場合、応募済み案件をレスポンスから除外する
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof V1Api
     */
    public getUserRecommendedJobOffers(limit?: number, excludeApplied?: boolean, options?: RawAxiosRequestConfig) {
        return V1ApiFp(this.configuration).getUserRecommendedJobOffers(limit, excludeApplied, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 関連するお仕事一覧を取得する
     * @summary list related job offers
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof V1Api
     */
    public getUserRelatedJobOffers(options?: RawAxiosRequestConfig) {
        return V1ApiFp(this.configuration).getUserRelatedJobOffers(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 保存済み検索条件一覧を取得します
     * @summary list searching bookmarks
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof V1Api
     */
    public getUserSearchingBookmarks(options?: RawAxiosRequestConfig) {
        return V1ApiFp(this.configuration).getUserSearchingBookmarks(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary get user skill relations
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof V1Api
     */
    public getUserSkillRelations(options?: RawAxiosRequestConfig) {
        return V1ApiFp(this.configuration).getUserSkillRelations(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary 登録後にやることリストの状態を取得する
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof V1Api
     */
    public getUserTodoList(options?: RawAxiosRequestConfig) {
        return V1ApiFp(this.configuration).getUserTodoList(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary get work preference
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof V1Api
     */
    public getWorkPreference(options?: RawAxiosRequestConfig) {
        return V1ApiFp(this.configuration).getWorkPreference(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary update client contract extension request
     * @param {string} accessToken 
     * @param {UpdateClientContractExtensionRequest} [updateClientContractExtensionRequest] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof V1Api
     */
    public updateClientContractExtensionRequest(accessToken: string, updateClientContractExtensionRequest?: UpdateClientContractExtensionRequest, options?: RawAxiosRequestConfig) {
        return V1ApiFp(this.configuration).updateClientContractExtensionRequest(accessToken, updateClientContractExtensionRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * ClientStaffのパスワードを設定する
     * @summary update client staff password
     * @param {string} staffToken 
     * @param {UpdateClientStaffPasswordRequest} [updateClientStaffPasswordRequest] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof V1Api
     */
    public updateClientStaffPassword(staffToken: string, updateClientStaffPasswordRequest?: UpdateClientStaffPasswordRequest, options?: RawAxiosRequestConfig) {
        return V1ApiFp(this.configuration).updateClientStaffPassword(staffToken, updateClientStaffPasswordRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary put job offers favorite
     * @param {number} id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof V1Api
     */
    public updateJobOffersFavorite(id: number, options?: RawAxiosRequestConfig) {
        return V1ApiFp(this.configuration).updateJobOffersFavorite(id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 紹介者ページで紹介者用URLに付与するトークンを発行する
     * @summary update referral token
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof V1Api
     */
    public updateUserReferralToken(options?: RawAxiosRequestConfig) {
        return V1ApiFp(this.configuration).updateUserReferralToken(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary update user skill relations
     * @param {UpdateUserSkillRelationsRequest} updateUserSkillRelationsRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof V1Api
     */
    public updateUserSkillRelations(updateUserSkillRelationsRequest: UpdateUserSkillRelationsRequest, options?: RawAxiosRequestConfig) {
        return V1ApiFp(this.configuration).updateUserSkillRelations(updateUserSkillRelationsRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary update work preference
     * @param {WorkPreferenceForm} workPreferenceForm 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof V1Api
     */
    public updateWorkPreference(workPreferenceForm: WorkPreferenceForm, options?: RawAxiosRequestConfig) {
        return V1ApiFp(this.configuration).updateWorkPreference(workPreferenceForm, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * メンバーのメールアドレスとパスワードでログインする
     * @summary member login
     * @param {number} [jobOfferId] 
     * @param {UserLoginRequest} [userLoginRequest] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof V1Api
     */
    public userLogin(jobOfferId?: number, userLoginRequest?: UserLoginRequest, options?: RawAxiosRequestConfig) {
        return V1ApiFp(this.configuration).userLogin(jobOfferId, userLoginRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * メンバーをログアウトする
     * @summary member logout
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof V1Api
     */
    public userLogout(options?: RawAxiosRequestConfig) {
        return V1ApiFp(this.configuration).userLogout(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary create
     * @param {VerifyClientStaffEmailRequest} [verifyClientStaffEmailRequest] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof V1Api
     */
    public verifyClientStaffEmail(verifyClientStaffEmailRequest?: VerifyClientStaffEmailRequest, options?: RawAxiosRequestConfig) {
        return V1ApiFp(this.configuration).verifyClientStaffEmail(verifyClientStaffEmailRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * ClientStaffのアクセストークンを検証する
     * @summary verify client staff access token
     * @param {string} staffToken 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof V1Api
     */
    public verifyClientStaffToken(staffToken: string, options?: RawAxiosRequestConfig) {
        return V1ApiFp(this.configuration).verifyClientStaffToken(staffToken, options).then((request) => request(this.axios, this.basePath));
    }
}

/**
 * @export
 */
export const GetClientBillYearsOrderEnum = {
    Asc: 'asc',
    Desc: 'desc'
} as const;
export type GetClientBillYearsOrderEnum = typeof GetClientBillYearsOrderEnum[keyof typeof GetClientBillYearsOrderEnum];
/**
 * @export
 */
export const GetClientBillsStatusEnum = {
    ConfirmRequested: 'confirmRequested',
    Confirmed: 'confirmed',
    Paid: 'paid'
} as const;
export type GetClientBillsStatusEnum = typeof GetClientBillsStatusEnum[keyof typeof GetClientBillsStatusEnum];
/**
 * @export
 */
export const GetClientBillsOrderEnum = {
    Status: 'status',
    InvoiceNumber: 'invoiceNumber',
    BilledOn: 'billedOn',
    BillLimitedOn: 'billLimitedOn'
} as const;
export type GetClientBillsOrderEnum = typeof GetClientBillsOrderEnum[keyof typeof GetClientBillsOrderEnum];
/**
 * @export
 */
export const GetClientBillsDirectionEnum = {
    Asc: 'asc',
    Desc: 'desc'
} as const;
export type GetClientBillsDirectionEnum = typeof GetClientBillsDirectionEnum[keyof typeof GetClientBillsDirectionEnum];
/**
 * @export
 */
export const GetClientQuestionnaireYearsOrderEnum = {
    Asc: 'asc',
    Desc: 'desc'
} as const;
export type GetClientQuestionnaireYearsOrderEnum = typeof GetClientQuestionnaireYearsOrderEnum[keyof typeof GetClientQuestionnaireYearsOrderEnum];
/**
 * @export
 */
export const GetClientQuestionnairesStatusEnum = {
    Unanswered: 'unanswered',
    Expired: 'expired',
    Answered: 'answered'
} as const;
export type GetClientQuestionnairesStatusEnum = typeof GetClientQuestionnairesStatusEnum[keyof typeof GetClientQuestionnairesStatusEnum];
/**
 * @export
 */
export const GetClientQuestionnairesOrderEnum = {
    Status: 'status',
    CreatedAt: 'createdAt',
    ExpiresAt: 'expiresAt'
} as const;
export type GetClientQuestionnairesOrderEnum = typeof GetClientQuestionnairesOrderEnum[keyof typeof GetClientQuestionnairesOrderEnum];
/**
 * @export
 */
export const GetClientQuestionnairesDirectionEnum = {
    Asc: 'asc',
    Desc: 'desc'
} as const;
export type GetClientQuestionnairesDirectionEnum = typeof GetClientQuestionnairesDirectionEnum[keyof typeof GetClientQuestionnairesDirectionEnum];
/**
 * @export
 */
export const GetUserJobOffersOrderEnum = {
    NewestFirst: 'newest_first',
    MinSalaryDesc: 'min_salary_desc',
    MaxSalaryDesc: 'max_salary_desc'
} as const;
export type GetUserJobOffersOrderEnum = typeof GetUserJobOffersOrderEnum[keyof typeof GetUserJobOffersOrderEnum];


